import countriesIso from './countries';

export default {
  // imports
  countriesIso,

  // main
  _meta: {
    version: '0.0.1',
    languageCodes: ['en-GB', 'it-IT'],
    languages: {
      'en-GB': 'English',
      'it-IT': 'Italiano',
    },
    flags: {
      'en-GB': 'flag-icon-gb',
      'it-IT': 'flag-icon-it',
      en: 'flag-icon-gb',
      it: 'flag-icon-it',
    },
  },
  qadra: {
    'en-GB': 'Qadra',
    'it-IT': 'Qadra',
  },
  cash: {
    'en-GB': 'Cash',
    'it-IT': 'Liquidità',
  },
  nav: {
    'en-GB': 'NAV',
    'it-IT': 'NAV',
  },
  ytd: {
    'en-GB': 'YTD',
    'it-IT': 'YTD',
  },
  fromStart: {
    'en-GB': 'From start',
    'it-IT': "Dall'inizio",
  },
  fromCreationDate: {
    'en-GB': 'From creation date',
    'it-IT': 'Dalla data di creazione',
  },
  progress: {
    'en-GB': 'Progress',
    'it-IT': 'Avanzamento',
  },
  other: {
    'en-GB': 'Other',
    'it-IT': 'Altro',
  },
  otherInvestments: {
    'en-GB': 'Other investments',
    'it-IT': 'Altri investimenti',
  },
  realEstate: {
    'en-GB': 'Real estate',
    'it-IT': 'Real estate',
  },
  loading: {
    'en-GB': 'Loading...',
    'it-IT': 'Caricamento...',
  },
  notAvailable: {
    'en-GB': 'Not available',
    'it-IT': 'Non disponibile',
  },
  unnamed: {
    'en-GB': '(no name)',
    'it-IT': '(senza nome)',
  },
  yes: {
    'en-GB': 'Yes',
    'it-IT': 'Sì',
  },
  no: {
    'en-GB': 'No',
    'it-IT': 'No',
  },
  start: {
    'en-GB': 'Start',
    'it-IT': 'Inizia',
  },
  back: {
    'en-GB': 'Back',
    'it-IT': 'Indietro',
  },
  clear: {
    'en-GB': 'Clear',
    'it-IT': 'Rimuovi',
  },
  proceed: {
    'en-GB': 'Proceed',
    'it-IT': 'Procedi',
  },
  refresh: {
    'en-GB': 'Refresh',
    'it-IT': 'Refresh',
  },
  optimize: {
    'en-GB': 'Optimize',
    'it-IT': 'Ottimizza',
  },
  dashboard: {
    'en-GB': 'Dashboard',
    'it-IT': 'Dashboard',
  },
  users: {
    'en-GB': 'Users',
    'it-IT': 'Utenti',
  },
  hello: {
    'en-GB': 'Hello',
    'it-IT': 'Ciao',
  },
  beneficiary: {
    'en-GB': 'Beneficiary',
    'it-IT': 'Intestatario',
  },
  totalWealth: {
    'en-GB': 'Total Wealth',
    'it-IT': 'Total Wealth',
  },
  today: {
    'en-GB': 'Today',
    'it-IT': 'Oggi',
  },
  name: {
    'en-GB': 'Name',
    'it-IT': 'Nome',
  },
  surname: {
    'en-GB': 'Surname',
    'it-IT': 'Cognome',
  },
  monthly: {
    'en-GB': 'Monthly',
    'it-IT': 'Mensile',
  },
  yearly: {
    'en-GB': 'Yearly',
    'it-IT': "All'anno",
  },
  email: {
    'en-GB': 'Email',
    'it-IT': 'Indirizzo email',
  },
  phoneNumber: {
    'en-GB': 'Phone Number',
    'it-IT': 'Numero di telefono',
  },
  phoneNumberNotRequired: {
    'en-GB': 'Phone Number (not required)',
    'it-IT': 'Numero di telefono (opzionale)',
  },
  phonePrefix: {
    'en-GB': 'Country code',
    'it-IT': 'Prefisso int.',
  },
  password: {
    'en-GB': 'Password',
    'it-IT': 'Password',
  },
  repeatPassword: {
    'en-GB': 'Repeat Password',
    'it-IT': 'Ripeti Password',
  },
  sex: {
    'en-GB': 'Sex',
    'it-IT': 'Sesso',
  },
  male: {
    'en-GB': 'Male',
    'it-IT': 'Maschio',
  },
  female: {
    'en-GB': 'Female',
    'it-IT': 'Femmina',
  },
  title: {
    'en-GB': 'Title',
    'it-IT': 'Titolo',
  },
  day: {
    'en-GB': 'Day',
    'it-IT': 'Giorno',
  },
  days: {
    'en-GB': 'Days',
    'it-IT': 'Giorni',
  },
  daysSymbol: {
    'en-GB': 'dd',
    'it-IT': 'gg',
  },
  month: {
    'en-GB': 'Month',
    'it-IT': 'Mese',
  },
  months: {
    'en-GB': 'Months',
    'it-IT': 'Mesi',
  },
  year: {
    'en-GB': 'Year',
    'it-IT': 'Anno',
  },
  years: {
    'en-GB': 'Years',
    'it-IT': 'Anni',
  },
  birthDate: {
    'en-GB': 'Birth date',
    'it-IT': 'Data di nascita',
  },
  dateOfBirth: {
    'en-GB': 'Birth date',
    'it-IT': 'Data di nascita',
  },
  yearOfBirth: {
    'en-GB': 'Year of birth',
    'it-IT': 'Anno di nascita',
  },
  country: {
    'en-GB': 'Country',
    'it-IT': 'Paese',
  },
  address: {
    'en-GB': 'Address',
    'it-IT': 'Indirizzo',
  },
  postCode: {
    'en-GB': 'Post code',
    'it-IT': 'CAP',
  },
  city: {
    'en-GB': 'City',
    'it-IT': 'Città',
  },
  province: {
    'en-GB': 'Province',
    'it-IT': 'Provincia',
  },
  edit: {
    'en-GB': 'Edit',
    'it-IT': 'Modifica',
  },
  add: {
    'en-GB': 'Add',
    'it-IT': 'Aggiungi',
  },
  cancel: {
    'en-GB': 'Cancel',
    'it-IT': 'Annulla',
  },
  create: {
    'en-GB': 'Create',
    'it-IT': 'Crea',
  },
  confirm: {
    'en-GB': 'Confirm',
    'it-IT': 'Conferma',
  },
  next: {
    'en-GB': 'Next',
    'it-IT': 'Avanti',
  },
  submit: {
    'en-GB': 'Submit',
    'it-IT': 'Invia',
  },
  accept: {
    'en-GB': 'Accept',
    'it-IT': 'Accetta',
  },
  ok: {
    'en-GB': 'Ok',
    'it-IT': 'Ok',
  },
  comingSoon: {
    'en-GB': 'Coming soon',
    'it-IT': 'In arrivo',
  },
  sendEmail: {
    'en-GB': 'Send email',
    'it-IT': 'Invia email',
  },
  delete: {
    'en-GB': 'Delete',
    'it-IT': 'Cancella',
  },
  document: {
    'en-GB': 'Document',
    'it-IT': 'Documento',
  },
  documents: {
    'en-GB': 'Documents',
    'it-IT': 'Documenti',
  },
  save: {
    'en-GB': 'Save',
    'it-IT': 'Salva',
  },
  saveEdit: {
    'en-GB': 'Save changes',
    'it-IT': 'Salva modifiche',
  },
  saveChanges: {
    'en-GB': 'Save changes',
    'it-IT': 'Salva modifiche',
  },
  saveProceed: {
    'en-GB': 'Save and proceed',
    'it-IT': 'Salva e procedi',
  },
  saveAndProceed: {
    'en-GB': 'Save and proceed',
    'it-IT': 'Salva e procedi',
  },
  required: {
    'en-GB': 'Required',
    'it-IT': 'Obbligatorio',
  },
  overview: {
    'en-GB': 'Overview',
    'it-IT': 'Dettagli',
  },
  goal: {
    'en-GB': 'Goal',
    'it-IT': 'Obiettivo',
  },
  portfolioProposal: {
    'en-GB': 'Portfolio proposal',
    'it-IT': 'Proposta di portafoglio',
  },
  portfolio: {
    'en-GB': 'Portfolio',
    'it-IT': 'Portafoglio',
  },
  view: {
    'en-GB': 'View',
    'it-IT': 'Visualizza',
  },
  risk: {
    'en-GB': 'Risk',
    'it-IT': 'Rischio',
  },
  riskLevel: {
    'en-GB': 'Risk level',
    'it-IT': 'Livello di rischio',
  },
  assets: {
    'en-GB': 'Assets',
    'it-IT': 'Asset',
  },
  liabilities: {
    'en-GB': 'Liabilities',
    'it-IT': 'Passività',
  },
  experience: {
    'en-GB': 'Experience',
    'it-IT': 'Esperienza',
  },
  loss: {
    'en-GB': 'Loss',
    'it-IT': 'Perdita',
  },
  gain: {
    'en-GB': 'Gain',
    'it-IT': 'Guadagno',
  },
  net: {
    'en-GB': 'Net',
    'it-IT': 'Netto',
  },
  invested: {
    'en-GB': 'Invested',
    'it-IT': 'Investito',
  },
  performance: {
    'en-GB': 'Performance',
    'it-IT': 'Performance',
  },
  expectedPerformance: {
    'en-GB': 'Expected performance',
    'it-IT': 'Performance attese',
  },
  forecast: {
    'en-GB': 'Forecast',
    'it-IT': 'Forecast',
  },
  volume: {
    'en-GB': 'Volume',
    'it-IT': 'Volume',
  },
  composition: {
    'en-GB': 'Composition',
    'it-IT': 'Composizione',
  },
  highRisk: {
    'en-GB': 'High risk',
    'it-IT': 'Alto rischio',
  },
  lowRisk: {
    'en-GB': 'Low risk',
    'it-IT': 'Basso rischio',
  },
  minRisk: {
    'en-GB': 'Min risk',
    'it-IT': 'Minimo rischio',
  },
  maxReturn: {
    'en-GB': 'Max return',
    'it-IT': 'Massimo rendimento',
  },
  pin: {
    'en-GB': 'PIN code',
    'it-IT': 'Codice PIN',
  },
  spouse: {
    'en-GB': 'Spouse',
    'it-IT': 'Coniuge',
  },
  progeny: {
    'en-GB': 'Son / Daughter',
    'it-IT': 'Figlio / Figlia',
  },
  others: {
    'en-GB': 'Others',
    'it-IT': 'Altri',
  },
  gender: {
    'en-GB': 'Gender',
    'it-IT': 'Sesso',
  },
  accountHolder: {
    'en-GB': 'Account holder',
    'it-IT': 'Intestatario',
  },
  wallet: {
    'en-GB': 'Wallet',
    'it-IT': 'Wallet',
  },
  portfolioProposals: {
    'en-GB': 'Portfolio proposals',
    'it-IT': "Proposte d'investimento",
  },
  date: {
    'en-GB': 'Date',
    'it-IT': 'Data',
  },
  step: {
    'en-GB': 'Step',
    'it-IT': 'Step',
  },
  operation: {
    'en-GB': 'Operation',
    'it-IT': 'Operazione',
  },
  status: {
    'en-GB': 'Status',
    'it-IT': 'Stato',
  },
  amount: {
    'en-GB': 'Amount',
    'it-IT': 'Valore',
  },
  deposit: {
    'en-GB': 'Deposit',
    'it-IT': 'Deposita',
  },
  withdraw: {
    'en-GB': 'Withdraw',
    'it-IT': 'Preleva',
  },
  finance: {
    'en-GB': 'Finance',
    'it-IT': 'Finanzia',
  },
  invest: {
    'en-GB': 'Invest',
    'it-IT': 'Investi',
  },
  liquidate: {
    'en-GB': 'Liquidate',
    'it-IT': 'Liquida',
  },
  liquidAssets: {
    'en-GB': 'Liquid assets',
    'it-IT': 'Liquidità',
  },
  total: {
    'en-GB': 'Total',
    'it-IT': 'Totale',
  },
  filters: {
    'en-GB': 'Filters',
    'it-IT': 'Filtri',
  },
  filterBy: {
    'en-GB': 'Filter by',
    'it-IT': 'Filtra per',
  },
  interval: {
    'en-GB': 'Interval',
    'it-IT': 'Intervallo',
  },
  yearToDate: {
    'en-GB': 'Year to date',
    'it-IT': 'Year to date',
  },
  all: {
    'en-GB': 'All',
    'it-IT': 'Tutti',
  },
  year1: {
    'en-GB': '1 year',
    'it-IT': '1 anno',
  },
  years5: {
    'en-GB': '5 years',
    'it-IT': '5 anni',
  },
  of: {
    'en-GB': 'of',
    'it-IT': 'di',
  },
  apply: {
    'en-GB': 'Apply',
    'it-IT': 'Applica',
  },
  cumulativeReturn: {
    'en-GB': 'Cumulative Return',
    'it-IT': 'Rendimento Cumulato',
  },
  returnYTD: {
    'en-GB': 'YTD Return',
    'it-IT': 'Rendimento YTD',
  },
  return1Yr: {
    'en-GB': 'Return 1Y',
    'it-IT': 'Rendimento 1Y',
  },
  return3Yrs: {
    'en-GB': 'Return 3Y',
    'it-IT': 'Rendimento 3Y',
  },
  return5Yr: {
    'en-GB': 'Return 5Y',
    'it-IT': 'Rendimento 5Y',
  },
  ytdReturn: {
    'en-GB': 'YTD Return',
    'it-IT': 'Rendimento YTD',
  },
  annualReturn: {
    'en-GB': 'Annual return',
    'it-IT': 'Rendimento annuale',
  },
  returnAnnualized: {
    'en-GB': 'Annualized return',
    'it-IT': 'Rendimento annualizzato',
  },
  annualizedReturn: {
    'en-GB': 'Annualized return',
    'it-IT': 'Rendimento annualizzato',
  },
  expectedReturn: {
    'en-GB': 'Expected return',
    'it-IT': 'Rendimento atteso',
  },
  return: {
    'en-GB': 'Return',
    'it-IT': 'Rendimento',
  },
  returnMax: {
    'en-GB': 'Max Return',
    'it-IT': 'Rendimento Max',
  },
  totalReturn: {
    'en-GB': 'Total Return',
    'it-IT': 'Rendimento Totale',
  },
  volatility: {
    'en-GB': 'Volatility',
    'it-IT': 'Volatilità',
  },
  var: {
    'en-GB': 'VaR',
    'it-IT': 'VaR',
  },
  potentialRisk: {
    'en-GB': 'Potential Risk',
    'it-IT': 'Rischio Potenziale',
  },
  sharpe: {
    'en-GB': 'Sharpe',
    'it-IT': 'Sharpe',
  },
  timeToRecovery: {
    'en-GB': 'Time to Recovery',
    'it-IT': 'Time to Recovery',
  },
  maxDrawdown: {
    'en-GB': 'Max Drawdown',
    'it-IT': 'Max Drawdown',
  },
  mgmtFee: {
    'en-GB': 'Mgmt Fee',
    'it-IT': 'Mgmt Fee',
  },
  managementFee: {
    'en-GB': 'Management Fee',
    'it-IT': 'Management Fee',
  },
  perfFee: {
    'en-GB': 'Performance Fee',
    'it-IT': 'Performance Fee',
  },
  performanceFee: {
    'en-GB': 'Performance Fee',
    'it-IT': 'Performance Fee',
  },
  assetClass: {
    'en-GB': 'Asset Class',
    'it-IT': 'Asset Class',
  },
  issuer: {
    'en-GB': 'Issuer',
    'it-IT': 'Issuer',
  },
  subAssetClass: {
    'en-GB': 'Sub Asset Class',
    'it-IT': 'Sub Asset Class',
  },
  category: {
    'en-GB': 'Category',
    'it-IT': 'Categoria',
  },
  probability: {
    'en-GB': 'Probability',
    'it-IT': 'Probabilità',
  },
  index: {
    'en-GB': 'Index',
    'it-IT': 'Index',
  },
  currency: {
    'en-GB': 'Currency',
    'it-IT': 'Valuta',
  },
  currencies: {
    'en-GB': 'Currencies',
    'it-IT': 'Valute',
  },
  allocation: {
    'en-GB': 'Allocation',
    'it-IT': 'Ripartizione',
  },
  correlation: {
    'en-GB': 'Correlation',
    'it-IT': 'Correlazione',
  },
  graphicSummary: {
    'en-GB': 'Graphic Summary',
    'it-IT': 'Riepilogo Grafico',
  },
  percentage: {
    'en-GB': 'Percentage',
    'it-IT': 'Percentuale',
  },
  value: {
    'en-GB': 'Value',
    'it-IT': 'Valore',
  },
  suggestedValue: {
    'en-GB': 'Suggested value',
    'it-IT': 'Valore suggerito',
  },
  currentValue: {
    'en-GB': 'Current value',
    'it-IT': 'Valore attuale',
  },
  updatedPerformance: {
    'en-GB': 'Updated Performance',
    'it-IT': 'Andamento aggiornato',
  },
  assetsAndStrategy: {
    'en-GB': 'Assets and Strategy',
    'it-IT': 'Beni e Strategia',
  },
  detailsRiskAndComposition: {
    'en-GB': 'Details, Risk and Composition',
    'it-IT': 'Dettagli, Rischio e Composizione',
  },
  detailsAndRisk: {
    'en-GB': 'Details and Risk',
    'it-IT': 'Dettagli e Rischio',
  },
  totalAmount: {
    'en-GB': 'Total amount',
    'it-IT': 'Valore totale',
  },
  error: {
    'en-GB': 'Error',
    'it-IT': 'Errore',
  },
  isin: {
    'en-GB': 'ISIN',
    'it-IT': 'ISIN',
  },
  sector: {
    'en-GB': 'Sector',
    'it-IT': 'Settore',
  },
  mer: {
    'en-GB': 'Mean Excess Return',
    'it-IT': 'Mean Excess Return',
  },
  tev: {
    'en-GB': 'Tracking Error Volatility',
    'it-IT': 'Tracking Error Volatility',
  },
  forecastScore: {
    'en-GB': 'Forecast Score',
    'it-IT': 'Punteggio Forecast',
  },
  forecastPrecision: {
    'en-GB': 'Forecast Precision',
    'it-IT': 'Precisione Forecast',
  },
  favorable: {
    'en-GB': 'Positive',
    'it-IT': 'Favorevole',
  },
  unfavorable: {
    'en-GB': 'Negative',
    'it-IT': 'Sfavorevole',
  },
  positive: {
    'en-GB': 'Positive',
    'it-IT': 'Favorevole',
  },
  negative: {
    'en-GB': 'Negative',
    'it-IT': 'Sfavorevole',
  },
  expected: {
    'en-GB': 'Expected',
    'it-IT': 'Atteso',
  },
  positiveScenario: {
    'en-GB': 'Positive scenario',
    'it-IT': 'Scenario favorevole',
  },
  expectedScenario: {
    'en-GB': 'Expected scenario',
    'it-IT': 'Scenario atteso',
  },
  negativeScenario: {
    'en-GB': 'Negative scenario',
    'it-IT': 'Scenario sfavorevole',
  },
  holding: {
    'en-GB': 'Holding',
    'it-IT': 'Titolo',
  },
  holdings: {
    'en-GB': 'Holdings',
    'it-IT': 'Titoli',
  },
  cluster: {
    'en-GB': 'Cluster',
    'it-IT': 'Cluster',
  },
  rating: {
    'en-GB': 'Rating',
    'it-IT': 'Rating',
  },
  weight: {
    'en-GB': 'Weight',
    'it-IT': 'Peso',
  },
  rhoPeer: {
    'en-GB': 'Rho Peer',
    'it-IT': 'Rho Peer',
  },
  euclideanPeer: {
    'en-GB': 'Euclidean Peer',
    'it-IT': 'Euclidean Peer',
  },
  accountsLabel: {
    'en-GB': 'Accounts',
    'it-IT': 'Account',
  },
  wealth: {
    'en-GB': 'Wealth',
    'it-IT': 'Patrimonio',
  },
  insOuts: {
    'en-GB': 'Ins/Outs',
    'it-IT': 'Entrate/Uscite',
  },
  publish: {
    'en-GB': 'Publish',
    'it-IT': 'Pubblica',
  },
  compare: {
    'en-GB': 'Compare',
    'it-IT': 'Compara',
  },
  select: {
    'en-GB': 'Select',
    'it-IT': 'Seleziona',
  },
  selected: {
    'en-GB': 'Selected',
    'it-IT': 'Selezionati',
  },
  deselect: {
    'en-GB': 'Deselect',
    'it-IT': 'Deseleziona',
  },
  remove: {
    'en-GB': 'Remove',
    'it-IT': 'Rimuovi',
  },
  removeAll: {
    'en-GB': 'Remove All',
    'it-IT': 'Rimuovi Tutti',
  },
  restore: {
    'en-GB': 'Restore',
    'it-IT': 'Ripristina',
  },
  rename: {
    'en-GB': 'Rename',
    'it-IT': 'Rinomina',
  },
  details: {
    'en-GB': 'Details',
    'it-IT': 'Dettagli',
  },
  viewDetails: {
    'en-GB': 'View details',
    'it-IT': 'Visualizza dettagli',
  },
  createCopy: {
    'en-GB': 'Create Copy',
    'it-IT': 'Crea Copia',
  },
  saveDraft: {
    'en-GB': 'Save Draft',
    'it-IT': 'Salva Bozza',
  },
  accepted: {
    'en-GB': 'Accepted',
    'it-IT': 'Accettata',
  },
  published: {
    'en-GB': 'Published',
    'it-IT': 'Pubblicata',
  },
  draft: {
    'en-GB': 'Draft',
    'it-IT': 'Bozza',
  },
  profileInfos: {
    'en-GB': 'Profile Infos',
    'it-IT': 'Info Profilo',
  },
  information: {
    'en-GB': 'Information',
    'it-IT': 'Informazioni',
  },
  message: {
    'en-GB': 'Message',
    'it-IT': 'Messaggio',
  },
  state: {
    'en-GB': 'State',
    'it-IT': 'Stato',
  },
  phone: {
    'en-GB': 'Phone',
    'it-IT': 'Telefono',
  },
  origin: {
    'en-GB': 'Origin',
    'it-IT': 'Origine',
  },
  yourAccounts: {
    'en-GB': 'Your Accounts',
    'it-IT': 'I Tuoi Account',
  },
  type: {
    'en-GB': 'Type',
    'it-IT': 'Tipo',
  },
  period: {
    'en-GB': 'Period',
    'it-IT': 'Periodo',
  },
  periodStart: {
    'en-GB': 'Period Start',
    'it-IT': 'Inizio del Periodo',
  },
  periodEnd: {
    'en-GB': 'Period End',
    'it-IT': 'Fine del Periodo',
  },
  yourMiFIDProfile: {
    'en-GB': 'Your MiFID profile',
    'it-IT': 'Il tuo profilo MiFID',
  },
  holder: {
    'en-GB': 'Holder',
    'it-IT': 'Intestatario',
  },
  owner: {
    'en-GB': 'Owner',
    'it-IT': 'Intestatario',
  },
  download: {
    'en-GB': 'Download',
    'it-IT': 'Scarica',
  },
  fees: {
    'en-GB': 'Fees',
    'it-IT': 'Fee',
  },
  contacts: {
    'en-GB': 'Contacts',
    'it-IT': 'Contatti',
  },
  clients: {
    'en-GB': 'Clients',
    'it-IT': 'Clienti',
  },
  leads: {
    'en-GB': 'Leads',
    'it-IT': 'Lead',
  },
  account: {
    'en-GB': 'Account',
    'it-IT': 'Account',
  },
  clientObjectives: {
    'en-GB': 'Client Objectives',
    'it-IT': 'Obiettivi Cliente',
  },
  objectives: {
    'en-GB': 'Objectives',
    'it-IT': 'Obiettivi',
  },
  objective: {
    'en-GB': 'Objective',
    'it-IT': 'Obiettivo',
  },
  signup: {
    'en-GB': 'Signup',
    'it-IT': 'Registrati',
  },
  needHelp: {
    'en-GB': 'Need help?',
    'it-IT': 'Serve aiuto?',
  },
  visitQadraWebsite: {
    'en-GB': 'Visit Qadra.com',
    'it-IT': 'Visita Qadra.com',
  },
  copy: {
    'en-GB': 'Copy',
    'it-IT': 'Copia',
  },
  copied: {
    'en-GB': 'Copied',
    'it-IT': 'Copiato',
  },
  createdAt: {
    'en-GB': 'Created at',
    'it-IT': 'Creato il',
  },
  investmentDuration: {
    'en-GB': 'Investment horizon',
    'it-IT': "Orizzonte d'investimento",
  },
  targetAmount: {
    'en-GB': 'Target amount',
    'it-IT': 'Importo obiettivo',
  },
  createDate: {
    'en-GB': 'Create date',
    'it-IT': 'Data creazione',
  },
  mandates: {
    'en-GB': 'Mandates',
    'it-IT': 'Linee di Gestione',
  },
  mixedBenchmark: {
    'en-GB': 'Mixed Benchmark',
    'it-IT': 'Mixed Benchmark',
  },
  investibleUniverse: {
    'en-GB': 'Investible Universe',
    'it-IT': 'Universo Investibile',
  },
  peers: {
    'en-GB': 'Peers',
    'it-IT': 'Peer',
  },
  recommended: {
    'en-GB': 'Recommended',
    'it-IT': 'Raccomandato',
  },
  recommend: {
    'en-GB': 'Recommend',
    'it-IT': 'Raccomanda',
  },
  removeFromRecommended: {
    'en-GB': 'Remove from Recommended',
    'it-IT': 'Rimuovi da Raccomandati',
  },
  recommendedByQadra: {
    'en-GB': 'Recommended by Qadra',
    'it-IT': 'Raccomandato da Qadra',
  },
  investments: {
    'en-GB': 'Investments',
    'it-IT': 'Investimenti',
  },
  markets: {
    'en-GB': 'Markets',
    'it-IT': 'Mercati',
  },
  assetSearchPlaceholder: {
    'en-GB': 'Select an asset',
    'it-IT': 'Seleziona un asset',
  },
  search: {
    'en-GB': 'Search',
    'it-IT': 'Ricerca',
  },
  advancedSearch: {
    'en-GB': 'Advanced search',
    'it-IT': 'Ricerca avanzata',
  },
  sharePersonalLink: {
    'en-GB': 'Share Personal Link',
    'it-IT': 'Condividi Link Personale',
  },
  howCalculateScenarios: {
    'en-GB': 'How do we calculate scenarios? Find out more.',
    'it-IT': 'Come calcoliamo gli scenari? Scopri di più.',
  },
  initialInvestment: {
    'en-GB': 'Initial investment',
    'it-IT': 'Investimento iniziale',
  },
  annualInvestment: {
    'en-GB': 'Annual top up',
    'it-IT': 'Investimento annuale',
  },
  alertPerformanceChart: {
    'en-GB':
      'The returns shown represent past performance and this is not a reliable indicator of future returns.',
    'it-IT':
      "I rendimenti mostrati rappresentano la performance passata e questa non è un'indicatore affidabile dei rendimenti futuri.",
  },
  leavingPageMessages: {
    loseChanges: {
      'en-GB': 'Are you sure you want to leave this page? Every change will be lost.',
      'it-IT': 'Sei sicuro di voler lasciare questa pagina? Ogni modifica verrà persa.',
    },
  },
  userTitles: {
    'it-IT': ['Sig.', 'Sig.ra', 'Sig.na'],
    'en-GB': ['Mr.', 'Mrs.', 'Miss'],
  },
  // errors.json
  errorMessage: {
    generic: {
      'en-GB': 'There was an error',
      'it-IT': "C'è stato un problema",
    },
    mustBeLowerThan: {
      'en-GB': 'Value must be a lower than {0}',
      'it-IT': 'Il valore deve essere più basso di {0}',
    },
    mustBeHigherThan: {
      'en-GB': 'Value must be a higher than {0}',
      'it-IT': 'Il valore deve essere più alto di {0}',
    },
    mustBeNumber: {
      'en-GB': 'Value must be a number',
      'it-IT': 'Il valore deve essere un numero',
    },
    idNotValid: {
      'en-GB': 'The ID is not valid',
      'it-IT': "L'ID non è valid",
    },
    emailNotValid: {
      'en-GB': 'Email not valid',
      'it-IT': 'Email non valida',
    },
    phoneNotValid: {
      'en-GB': 'Phone number not valid',
      'it-IT': 'Numero di telefono non valido',
    },
    emailRequired: {
      'en-GB': 'Email required',
      'it-IT': 'Email obbligatoria',
    },
    nameRequired: {
      'en-GB': 'Name required',
      'it-IT': 'Nome obbligatorio',
    },
    titleRequired: {
      'en-GB': 'Title required',
      'it-IT': 'Titolo obbligatorio',
    },
    surnameRequired: {
      'en-GB': 'Surname required',
      'it-IT': 'Cognome obbligatorio',
    },
    passwordRequired: {
      'en-GB': 'Password required',
      'it-IT': 'Password obbligatorio',
    },
    passwordNotValid: {
      'en-GB': 'Password not valid',
      'it-IT': 'Password non valida',
    },
    passwordNotEqual: {
      'en-GB': 'Password not equal',
      'it-IT': 'Password non uguale',
    },
    captchaWrong: {
      'en-GB': 'Captcha is missing or wrong',
      'it-IT': 'Captcha mancante o sbagliato',
    },
    maxDrawdownNotAvailable: {
      'en-GB': 'There are no data available for this scenario, try another one.',
      'it-IT': 'Non ci sono dati disponibili per questo scenario, provane un altro.',
    },
    modelNotFound: {
      'en-GB': 'This model is not available.',
      'it-IT': 'Questo modello non è disponibile.',
    },
  },
  // users.json
  userCreateSection: {
    thumbnailImage: {
      'en-GB': 'Thumbnail Image URL',
      'it-IT': 'Thumbnail Immagine URL',
    },
    profileImage: {
      'en-GB': 'Profile Image URL',
      'it-IT': 'Profilo Immagine URL',
    },
  },
  // users.json
  userCreateSuccess: {
    user: {
      'en-GB': 'User',
      'it-IT': 'Utente',
    },
    client: {
      'en-GB': 'Client',
      'it-IT': 'Cliente',
    },
    successCreated: {
      'en-GB': 'successfully created!',
      'it-IT': 'creato con successo!',
    },
    emailSent1: {
      'en-GB': 'We have sent an email with instructions for login',
      'it-IT': 'Abbiamo inviato una email con le istruzioni per effettuare l’accesso',
    },
    emailSent1client: {
      'en-GB': 'to the client',
      'it-IT': 'al cliente',
    },
    emailSent1user: {
      'en-GB': 'to the user',
      'it-IT': "all'utente",
    },
    emailSent2: {
      'en-GB': 'email address and to his mobile phone. He should get them within 10 minutes.',
      'it-IT': 'all’indirizzo email e al suo cellulare. Dovrebbe riceverli entro 10 minuti.',
    },
  },
  // profile.json
  profile: {
    sectionTitle: {
      'en-GB': 'My profile',
      'it-IT': 'Il mio profilo',
    },
    sectionTitleEdit: {
      'en-GB': 'Modify profile',
      'it-IT': 'Modifica profilo',
    },
    info: {
      label: {
        'en-GB': 'Personal info',
        'it-IT': 'Info personali',
      },
      title: {
        'en-GB': 'Title',
        'it-IT': 'Titolo',
      },
      name: {
        'en-GB': 'Name',
        'it-IT': 'Nome',
      },
      surname: {
        'en-GB': 'Surname',
        'it-IT': 'Cognome',
      },
      sex: {
        'en-GB': 'Sex',
        'it-IT': 'nome',
      },
    },
    contacts: {
      label: {
        'en-GB': 'Contacts',
        'it-IT': 'Contatti',
      },
      email: {
        'en-GB': 'Email',
        'it-IT': 'Email',
      },
      phone: {
        'en-GB': 'Phone',
        'it-IT': 'Cellulare',
      },
    },
    addresses: {
      label: {
        'en-GB': 'Addresses',
        'it-IT': 'Indirizzi',
      },
      addressName: {
        'en-GB': 'Address name',
        'it-IT': 'Nome indirizzo',
      },
      addressNamePlaceholder: {
        'en-GB': 'Home, Office ...',
        'it-IT': 'Casa, Ufficio ...',
      },
      deleteAddressModalTitle: {
        'en-GB': 'Delete address?',
        'it-IT': 'Cancella indirizzo?',
      },
      deleteAddressModalBody: {
        'en-GB': 'The address will be removed definitively.',
        'it-IT': "L'indirizzo verrà cancellato definitivamente.",
      },
    },
    docs: {
      label: {
        'en-GB': 'Documents',
        'it-IT': 'Documenti',
      },
      docType: {
        'en-GB': 'Document type',
        'it-IT': 'Tipo di documento',
      },
      docNumber: {
        'en-GB': 'Document number',
        'it-IT': 'Numero documento',
      },
      taxCode: {
        'en-GB': 'Tax code',
        'it-IT': 'Codice fiscale',
      },
      taxCodeCity: {
        'en-GB': 'Birth city',
        'it-IT': 'Luogo di nascita',
      },
      issueDate: {
        'en-GB': 'Issue date',
        'it-IT': 'Data di rilascio',
      },
      expiryDate: {
        'en-GB': 'Expiry date',
        'it-IT': 'Data di scadenza',
      },
      deleteDocModalTitle: {
        'en-GB': 'Delete document?',
        'it-IT': 'Cancella documento?',
      },
      deleteDocModalBody: {
        'en-GB': 'The document will be removed definitively.',
        'it-IT': 'Il documento verrà cancellato definitivamente.',
      },
      loadPhoto: {
        'en-GB': 'Load photo',
        'it-IT': 'Carica foto',
      },
      loadPhotoRemember: {
        'en-GB': 'Remember to load front and rear document photo.',
        'it-IT': 'Ricordati di caricare la foto del documento sia fronte che retro.',
      },
    },
  },
  riskLevels: {
    '1': {
      name: {
        'en-GB': 'Cautious',
        'it-IT': 'Prudente',
      },
      description: {
        'en-GB':
          'You are a prudent and risk-averse investor. You prefer to work with strategies that minimize volatility in exchange for lower returns. The right mix for you involves a majority of bonds and government bonds, with limited exposure to stock markets.',
        'it-IT':
          'Sei un investitore prudente e avverso al rischio. Preferisci operare con strategie che minimizzino la volatilità in cambio di rendimenti più contenuti. Il mix giusto per te prevede una maggioranza di obbligazioni e titoli di stato, con una limitata esposizione ai mercati azionari.',
      },
    },
    '2': {
      name: {
        'en-GB': 'Relaxed',
        'it-IT': 'Rilassato',
      },
      description: {
        'en-GB':
          'You are a prudent investor, but willing to take some temporary risks to get a slightly higher return. The ideal product mix for you includes a majority of bonds with a more limited exposure to equities, commodities and FX investments.',
        'it-IT':
          "Sei un investiore prudente, ma disposto ad assumersi qualche rischio temporaneo per ottenere un rendimento un po' più alto. Il mix di prodotti ideale per te comprende una maggioranza di obbligazioni con una esposizione più limitata a titoli azionari, commodities o FX.",
      },
    },
    '3': {
      name: {
        'en-GB': 'Balanced',
        'it-IT': 'Bilanciato',
      },
      description: {
        'en-GB':
          'You are an investor who is at ease even with more risky and diversified investments. Your ideal portfolio could include a balanced mix of bonds and stocks, with a residual percentage of Commodities and other investments.',
        'it-IT':
          'Sei un investiore che si trova a proprio agio anche con investimenti più rischiosi e diversificati. Un tuo portfolio ideale potrebbe comprendere un mix bilanciato di obbligazioni e azioni, con una percentuale residuale di Commodities e altri investimenti.',
      },
    },
    '4': {
      name: {
        'en-GB': 'Flexible',
        'it-IT': 'Flessibile',
      },
      description: {
        'en-GB':
          'You are an investor who favors returns, accepting fairly high levels of volatility. Your ideal portfolio mix has a majority of equity exposure, balanced by bonds and other asset classes.',
        'it-IT':
          'Sei un investitore che predilige il rendimento, accettando dei livelli di volatilità abbastanza elevati. Il tuo portfolio mix ideale prevede una maggioranza azionaria bilanciata da obbligazioni e altre asset class.',
      },
    },
    '5': {
      name: {
        'en-GB': 'Ambitious',
        'it-IT': 'Ambizioso',
      },
      description: {
        'en-GB':
          'You are an investor who does not suffer from exposure to risk, you prefer ambitious returns and are willing to take important risks to achieve them.',
        'it-IT':
          "Sei un investitore che non risente dell'esposizione al rischio, preferisci obiettivi di rendimento ambiziosi e sei disposto a correre dei rischi importanti per raggiungerli.",
      },
    },
  },
  accountTypes: {
    '1': {
      name: {
        'en-GB': 'Corporate',
        'it-IT': 'Aziendale',
      },
    },
    '2': {
      name: {
        'en-GB': 'Shared',
        'it-IT': 'Condiviso',
      },
    },
    '3': {
      name: {
        'en-GB': 'Personal',
        'it-IT': 'Personale',
      },
    },
    Corporate: {
      subTitle: {
        'en-GB': 'Business account',
        'it-IT': 'Account intestato ad una persona giuridica',
      },
      name: {
        'en-GB': 'Corporate',
        'it-IT': 'Corporate',
      },
    },
    Shared: {
      subTitle: {
        'en-GB': 'Multiple owners',
        'it-IT': 'Account condiviso con altri titolari',
      },
      name: {
        'en-GB': 'Shared',
        'it-IT': 'Condiviso',
      },
    },
    Personal: {
      subTitle: {
        'en-GB': 'Sole owner',
        'it-IT': 'Unico intestatario',
      },
      name: {
        'en-GB': 'Personal',
        'it-IT': 'Personale',
      },
    },
  },
  // modals.json
  modals: {
    proposalRequestChange: {
      title: {
        'en-GB': 'Request an investment proposal',
        'it-IT': "Richiedi una proposta d'investimento",
      },
      description: {
        'en-GB':
          'Provide some additional information on the investment proposal you would like to receive and submit the request to Qadra. When the new proposal is ready, you will receive an email to view its details.',
        'it-IT':
          "Fornisci qualche informazione in più sui parametri della proposta d'investimento che vorresti vengano rivisti ed inoltra la richiesta a Qadra. Quando la nuova proposta sarà pronta, riceverai una email per visualizzarne i dettagli.",
      },
      propertyLabel: {
        'en-GB': 'On what property should we focus to create your personalized proposal?',
        'it-IT': 'Su quale aspetto desideri impostare la tua proposta personalizzata?',
      },
      messageLabel: {
        'en-GB': 'If there is any specific request you can enter it here',
        'it-IT': 'Se desideri, inserisci qui le tue richieste specifiche',
      },
    },
    proposalChangeRequestSuccess: {
      title: {
        'en-GB': 'Request successfully sent',
        'it-IT': 'Richiesta inviata con successo',
      },
      description: {
        'en-GB':
          'Your request has been sent successfully, when the new proposal is ready, you will receive an email to view its details.',
        'it-IT':
          'La tua richiesta è stata inviata con successo, quando la nuova proposta sarà pronta, riceverai una email per visualizzarne i dettagli.',
      },
    },
    ticketsSuccess: {
      title: {
        'en-GB': 'Request successfully sent',
        'it-IT': 'Richiesta inviata con successo',
      },
      description: {
        'en-GB':
          'You will receive our assistance in the shortest possible time, directly on the personal email with which you are registered in Qadra.com.',
        'it-IT':
          'Riceverai la nostra assistenza nel minor tempo possibile, direttamente sulla mail personale con la quale sei registrato in Qadra.com',
      },
    },
    recommendInstrument: {
      title: {
        'en-GB': 'Changes confirmed',
        'it-IT': 'Modifiche confermate',
      },
      descriptionAdd: {
        'en-GB': 'The instruments have been added to "Recommended by Qadra"',
        'it-IT': 'I titoli sono stati aggiunti a "Raccomandati da Qadra"',
      },
      descriptionRemove: {
        'en-GB': 'The instruments have been removed from "Recommended by Qadra"',
        'it-IT': 'I titoli sono stati rimossi da "Raccomandati da Qadra"',
      },
    },
    signupSuccess: {
      title: {
        'en-GB': 'Request received successfully!',
        'it-IT': 'Richiesta ricevuta con successo!',
      },
      description: {
        'en-GB': 'Check your email and activate your account through the link received.',
        'it-IT':
          'Controlla nella tua posta elettronica ed attiva il tuo account attraverso il link ricevuto.',
      },
    },
    contactAdvisor: {
      title: {
        'en-GB': 'Contact your Wealth Manager',
        'it-IT': 'Contatta Advisor',
      },
      description: {
        'en-GB':
          'Hi {userName} your Wealth Manager is always available to help you, or to discuss your special requests.',
        'it-IT':
          'Ciao {userName}, puoi contattare il tuo Wealth Manager ai seguenti contatti per ricevere un chiarimento su un particolare campo o essere assistito durante la compilazione.',
      },
    },
    contactOwner: {
      title: {
        'en-GB': 'Contact client',
        'it-IT': 'Contatta cliente',
      },
      description: {
        'en-GB': 'Hello {userName}, you can contact your client at the following contacts.',
        'it-IT': 'Ciao {userName}, puoi contattare il tuo cliente ai seguenti contatti.',
      },
    },
    proposalPublish: {
      title: {
        'en-GB': 'Publish investment proposal',
        'it-IT': "Pubblica proposta d'investimento",
      },
      description: {
        'en-GB':
          'The proposal will be made available to your client. We will send a notification email to let your client know a new proposal is ready for him.',
        'it-IT':
          "La proposta sarà disponibile nell'elenco di proposte visionabili dal cliente. Verrà inviata una email di notifica per avvisare il cliente della nuova disponibilità.",
      },
      publish: {
        'en-GB': 'Publish',
        'it-IT': 'Pubblica',
      },
    },
    multipleProposalPublish: {
      title: {
        'en-GB': 'Publish multiple investment proposal',
        'it-IT': "Pubblica più proposte d'investimento",
      },
      description: {
        'en-GB':
          'The proposals will be made available to your client. We will send a notification email to let your client know new proposals are ready for him.',
        'it-IT':
          "Le proposte saranno disponibili nell'elenco di proposte visionabili dal cliente. Verrà inviata una email di notifica per avvisare il cliente delle nuove disponibilità.",
      },
      publish: {
        'en-GB': 'Publish',
        'it-IT': 'Pubblica',
      },
    },
    confirmDelegatedProfiling: {
      title: {
        'en-GB': '{0} will be working on your investor profile soon.',
        'it-IT': "{0} sarà presto al lavoro sul tuo profilo d'investitore.",
      },
      description: {
        'en-GB':
          'Once your profile is completed, you will receive a notification to review it together with your Wealth Manager and continue onboarding together.',
        'it-IT':
          'Una volta che il tuo profilo sarà compilato, riceverai una notifica per rivederlo insieme al tuo Wealth Manager e proseguire insieme nel tuo onboarding.',
      },
    },
  },
  statuses: {
    done: {
      'en-GB': 'Done',
      'it-IT': 'Completato',
    },
    pending: {
      'en-GB': 'Pending',
      'it-IT': 'In attesa',
    },
  },
  accounts: {
    label: {
      'en-GB': 'Accounts',
      'it-IT': 'Account',
    },
    searchPlaceholder: {
      'en-GB': 'Search account by ID or owner',
      'it-IT': 'Ricerca account per ID o intestatario',
    },
    accountDetails: {
      'en-GB': 'Account Details',
      'it-IT': 'Dettagli Account',
    },
    infoAndSettings: {
      'en-GB': 'Info & Settings',
      'it-IT': 'Informazioni & Impostazioni',
    },
    createProp: {
      'en-GB': 'Create proposal',
      'it-IT': 'Crea proposta',
    },
    nextStep: {
      'en-GB': 'Next Step',
      'it-IT': 'Next Step',
    },
    pending: {
      'en-GB': 'Pending',
      'it-IT': 'Pending',
    },
    complete: {
      'en-GB': 'View',
      'it-IT': 'Visualizza',
    },
    contactAdvisorLabel: {
      'en-GB': 'Contact Wealth Manager',
      'it-IT': 'Contatta Wealth Manager',
    },
    contactWMLabel: {
      'en-GB': 'Contact WM',
      'it-IT': 'Contatta WM',
    },
    goToAccountList: {
      'en-GB': 'Go to account list',
      'it-IT': 'Vai alla lista di account',
    },
    goToOwner: {
      'en-GB': 'Go to owner',
      'it-IT': "Vai all'intestatario",
    },
    yourRiskProfile: {
      'en-GB': [
        'Your risk profile is',
        'Here you can see the risk profile compared to your MiFID profile.',
      ],
      'it-IT': [
        'Il tuo profilo di rischio è di',
        'Qui puoi vedere il profilo di rischio rispetto al tuo profilo MiFID.',
      ],
    },
    yourRiskProfileProposal: {
      'en-GB': [
        'Your risk profile is',
        'Here you can see the risk profile of this proposal compared to your MiFID profile.',
      ],
      'it-IT': [
        'Il tuo profilo di rischio è di',
        'Qui puoi vedere il profilo di rischio di questa proposta rispetto al tuo profilo MiFID.',
      ],
    },
    yourRiskProfilePortfolio: {
      'en-GB': [
        'Your risk profile is',
        'Here you can see the risk profile of this portfolio compared to your MiFID profile.',
      ],
      'it-IT': [
        'Il tuo profilo di rischio è di',
        'Qui puoi vedere il profilo di rischio di questo portfolio rispetto al tuo profilo MiFID.',
      ],
    },
    // proposals.json
    portfolioProposals: {
      requestNewProposal: {
        'en-GB': 'Are you not satisfied with these proposals? Request a personalized one',
        'it-IT': 'Non sei soddisfatto con queste proposte? Richiedine una personalizzata',
      },
      acceptProposal: {
        'en-GB': 'Accept Proposal',
        'it-IT': 'Accetta Proposta',
      },
      profiling: {
        title: {
          'en-GB': 'Ready! Choose your investment proposal.',
          'it-IT': 'Ci siamo! Scegli la tua proposta d’investimento.',
        },
        description: {
          'en-GB': 'Choose an investment proposal:',
          'it-IT': 'Scegli una proposta d’investimento:',
        },
        yourRiskProfile: {
          'en-GB': 'Your risk profile:',
          'it-IT': 'Il tuo profilo di rischio è:',
        },
      },
      title: {
        'en-GB': 'How we would invest for you',
        'it-IT': "Le nostre proposte d'investimento per te",
      },
      description: {
        'en-GB':
          'Based on your investor profile, we have developed several investment proposals to suit your needs.<br/><br/>From here you can evaluate, compare and choose the investment strategy you prefer. If you need the help of an expert, or if you want a proposal other than the one you have developed, your Wealth Manager is always at your disposal.',
        'it-IT':
          "In base al tuo profilo d'investitore, abbiamo elaborato diverse proposte d’investimento adatte alle tue esigenze.<br/><br/>Da qui puoi valutare, confrontare e scegliere la strategia d'investimento che preferisci. Se ti servisse l'aiuto di un esperto, o volessi una proposta diversa da quelle elaborate, il tuo Wealth Manager è sempre a tua disposizione.",
      },
      card: {
        annualizedReturnTooltip: {
          'en-GB': 'Evaluate return potential in three different scenarios.',
          'it-IT': 'Osserva il rendimento potenziale in tre possibili scenari.',
        },
        riskProfileTooltip: {
          'en-GB':
            'Your risk profile represents the limit within which we can extend an investment proposal to you.',
          'it-IT':
            'Il profilo di rischio di una proposta deve essere uguale o minore rispetto al profilo di rischio complessivo asseganto al tuo account.',
        },
        disclaimer: {
          'en-GB':
            '* Performances are based on statistical projections and by no means intend to guarantee a financial performance.',
          'it-IT':
            '* Le performance riportate non sono indicative di potenziali rendimenti futuri.',
        },
      },
      initialInvestment: {
        'en-GB': 'Initial Investment',
        'it-IT': 'Investimento Iniziale',
      },
      investmentPeriod: {
        'en-GB': 'Investment Period',
        'it-IT': "Periodo d'Investimento",
      },
      detailsLabel: {
        'en-GB': 'Details',
        'it-IT': 'Dettagli',
      },
      returnLabel: {
        'en-GB': 'Return',
        'it-IT': 'Rendimento',
      },
      accountCompletion: {
        'en-GB': 'Account Completion',
        'it-IT': 'Completamento Account',
      },
      missingProposal: {
        'en-GB': 'There are no proposals available. Click on "Create Proposal" to create one.',
        'it-IT':
          'Non ci sono proposte di portfolio disponibili. Puoi crearne una cliccando su "Crea Proposta".',
      },
      createProposal: {
        'en-GB': 'Create Proposal',
        'it-IT': 'Crea Proposta',
      },
      compareProposalsLabel: {
        'en-GB': 'Compare the proposals',
        'it-IT': 'Compara le proposte',
      },
      compareLabel: {
        'en-GB': 'Compare',
        'it-IT': 'Compara',
      },
      createFromModel: {
        'en-GB': 'Create from Model',
        'it-IT': 'Crea da Modello',
      },
      createProposalFromModel: {
        'en-GB': 'Create new proposal from model',
        'it-IT': 'Crea nuova proposta da modello',
      },
      selectModel: {
        'en-GB': 'Select the model to start creating the proposal',
        'it-IT': 'Seleziona il modello dal quale partire per creare la proposta',
      },
      noModelsAvailable: {
        'en-GB': "There is no model available that matches the client's risk profile",
        'it-IT':
          'Non è disponibile nessun modello che corrisponda al profilo di rischio del cliente',
      },
      selectProposalsLabel: {
        'en-GB':
          'Select the portfolio proposals you want to compare. You can compare three at most.',
        'it-IT':
          "Seleziona le proposte d'investimento che vuoi comparare. Ne puoi confrontare al massimo tre.",
      },
      compareAndPublishProposalsLabel: {
        'en-GB':
          'Select the portfolio proposals you want to compare or publish. You can compare three at most.',
        'it-IT':
          "Seleziona le proposte d'investimento che vuoi comparare o pubblicare. Ne puoi confrontare al massimo tre.",
      },
      statusLabel: {
        accepted: {
          'en-GB': 'Selected',
          'it-IT': 'Selezionata',
        },
        published: {
          'en-GB': 'Published',
          'it-IT': 'Pubblicata',
        },
        draft: {
          'en-GB': 'Draft',
          'it-IT': 'Bozza',
        },
      },
      copyProposal: {
        'en-GB': 'Copy Portfolio Proposal',
        'it-IT': 'Copia Proposta Portfolio',
      },
      renameProposal: {
        'en-GB': 'Rename Portfolio Proposal',
        'it-IT': 'Rinomina Proposta Portfolio',
      },
      selectedProposal: {
        'en-GB': 'Selected Proposal',
        'it-IT': 'Proposta scelta',
      },
      viewAccountInfo: {
        'en-GB': 'View Account Information',
        'it-IT': 'Visualizza Dati Account',
      },
      mustViewProposalAlert: {
        'en-GB': 'To select a proposal you have to view its details before.',
        'it-IT': 'Per selezionare una proposta devi prima visualizzare i suoi dettagli.',
      },
      wmCreatingProposalAlert1: {
        'en-GB':
          'Your Wealth Manager is working on a proposal tailored to your risk profile. You will receive a notification email shortly.',
        'it-IT':
          'Il tuo Wealth Manager sta elaborando una proposta personalizzata al tuo profilo di rischio. A breve riceverai una email di notifica.',
      },
      wmCreatingProposalAlert2: {
        'en-GB':
          'Your Wealth Manager is preparing a personalized proposal for you.<br/><br/>You will receive an email notification shortly!',
        'it-IT':
          'Il tuo Wealth Manager sta preparando una proposta personalizzata per te.<br/><br/>A breve riceverai una notifica via email!',
      },
      noProposalAvailable: {
        'en-GB': 'There are no portfolio proposals available at the moment.',
        'it-IT': "Non ci sono proposte d'investimento disponibili al momento.",
      },
    },
    // proposals.json details
    proposalDetails: {
      selectProposal: {
        'en-GB': 'Select Proposal',
        'it-IT': 'Seleziona Proposta',
      },
      backToList: {
        'en-GB': 'Back to Proposals List',
        'it-IT': 'Indietro alla Lista di Proposte',
      },
      leavingPageMessage: {
        'en-GB': 'Are you sure you want to leave this page? Every change will be lost.',
        'it-IT': 'Sei sicuro di voler lasciare questa pagina? Ogni modifica verrà persa.',
      },
      optimizationSuccessful: {
        'en-GB':
          'Successful optimization! If you are satisfied with the proposal proceed to save it.',
        'it-IT':
          'Ottimizzazione riuscita! Se sei soddisfatto della proposta procedi con il salvataggio.',
      },
      fundSelectionToolSuccessful: {
        'en-GB': 'New funds added! Remember to optimize the proposal.',
        'it-IT': 'Nuovi fondi aggiunti! Ricordati di ottimizzare la proposta.',
      },
      backToProposal: {
        'en-GB': 'Back to proposal',
        'it-IT': 'Torna alla proposta',
      },
      addToProposal: {
        'en-GB': 'Add to proposal',
        'it-IT': 'Aggiungi alla proposta',
      },
      proposalOptimization: {
        title: {
          'en-GB': 'Proposal Optimization',
          'it-IT': 'Ottimizzazione Proposta',
        },
        backToProposal: {
          'en-GB': 'Back to proposal',
          'it-IT': 'Torna alla proposta',
        },
        confirmChanges: {
          'en-GB': 'Confirm Changes',
          'it-IT': 'Conferma Modifica',
        },
        changeProposal: {
          'en-GB': 'Change Proposal',
          'it-IT': 'Cambia Proposta',
        },
        placeholderText: {
          'en-GB': 'Set the parameters for optimization to have a rebalanced proposal.',
          'it-IT': 'Imposta i parametri per l’ottimizzazione per avere una proposta ribilanciata.',
        },
        runOptimization: {
          'en-GB': 'Run Optimization',
          'it-IT': 'Ottimizza Proposta',
        },
        valueRangeWarning: {
          'en-GB': 'Values must be valid numbers with no more than two decimals.',
          'it-IT': 'I valori devono essere un numero valido con non più di due decimali.',
        },
        minGreaterThanMaxWarning: {
          'en-GB': 'Min is greater than max',
          'it-IT': 'Il valore minimo è più alto del massimo',
        },
        minWeight: {
          'en-GB': 'Min weight',
          'it-IT': 'Peso min',
        },
        maxWeight: {
          'en-GB': 'Max weight',
          'it-IT': 'Peso max',
        },
        min: {
          'en-GB': 'Min',
          'it-IT': 'Min',
        },
        max: {
          'en-GB': 'Max',
          'it-IT': 'Max',
        },
        optimizationCriteria: {
          'en-GB': 'Optimization criteria',
          'it-IT': 'Criteri di ottimizzazione',
        },

        criteriaDescription: {
          'en-GB':
            'Select for which assets you want to optimize the proposal, with the relative minimum and/or maximum weight.',
          'it-IT':
            'Seleziona per quali asset vuoi ottimizzare la proposta, con il relativo peso minimo e/o massimo.',
        },
        selectPlaceholder: {
          'en-GB': 'Select an asset',
          'it-IT': 'Seleziona un asset',
        },
      },
      searchFundsAndMandates: {
        'en-GB': 'Search funds or mandates',
        'it-IT': 'Ricerca fondi o linee di gestione.',
      },
      backToAccountCompletion: {
        'en-GB': 'Go Back To Account Completion',
        'it-IT': 'Torna A Completamento Account',
      },
      acceptProposalLabel: {
        'en-GB': 'Select Proposal',
        'it-IT': 'Seleziona Proposta',
      },
      backToProposalsLabel: {
        'en-GB': 'Back to proposals',
        'it-IT': 'Torna alle proposte',
      },
      backToDashboard: {
        'en-GB': 'Back to dashboard',
        'it-IT': 'Torna alla dashboard',
      },
      backToInvestments: {
        'en-GB': 'Back to investments',
        'it-IT': 'Torna agli investimenti',
      },
      currencyLabel: {
        'en-GB': 'Currencies',
        'it-IT': 'Valute',
      },
      correlationLabel: {
        'en-GB': 'Correlation',
        'it-IT': 'Correlazione',
      },
      returnLabel: {
        'en-GB': 'Return',
        'it-IT': 'Rendimento',
      },
      returnYtdLabel: {
        'en-GB': 'YTD return',
        'it-IT': 'Rendimento YTD',
      },
      totalAmountLabel: {
        'en-GB': 'Total amount',
        'it-IT': 'Valore totale',
      },
      performanceGraphPlaceholderText: {
        'en-GB':
          'Our Asset Managers are setting up your portfolio. As soon as it is ready you will receive a notification and can check its performance in this screen.',
        'it-IT':
          'I nostri Asset Manager stanno creando il tuo portafoglio. Non appena sarà pronto, riceverai una notifica e potrai verificarne le performance in questa schermata.',
      },
      historicalPerformance: {
        'en-GB': 'Historical Performance',
        'it-IT': 'Performance Storica',
      },
      selectBenchmark: {
        'en-GB': 'Select Benchmark',
        'it-IT': 'Seleziona Benchmark',
      },
      riskLabel: {
        'en-GB': 'Risk',
        'it-IT': 'Rischio',
      },
      selectAnInterval: {
        'en-GB':
          'Select a time interval to project the performance of the portfolio in past years.',
        'it-IT':
          "Seleziona un intervallo di tempo per proiettare l'andamento del portfolio negli anni passati.",
      },
      yourProfileLabel: {
        'en-GB': 'Your MiFID profile',
        'it-IT': 'Il tuo profilo MiFID',
      },
      highRiskLabel: {
        'en-GB': 'high risk',
        'it-IT': 'alto rischio',
      },
      lowRiskLabel: {
        'en-GB': 'low risk',
        'it-IT': 'basso rischio',
      },
      compositionLabel: {
        'en-GB': 'Composition',
        'it-IT': 'Composizione',
      },
      holdingsNamesLabel: {
        'en-GB': 'Holdings',
        'it-IT': 'Titoli',
      },
      weightLabel: {
        'en-GB': 'Weight',
        'it-IT': 'Peso',
      },
      valueLabel: {
        'en-GB': 'Value',
        'it-IT': 'Valore',
      },
      varLabel: {
        'en-GB': 'VaR',
        'it-IT': 'VaR',
      },
      sharpeLabel: {
        'en-GB': 'Sharpe',
        'it-IT': 'Sharpe',
      },
      timeToRecoveryLabel: {
        'en-GB': 'Time to Recovery',
        'it-IT': 'Time to Recovery',
      },
      maxDrawdownLabel: {
        'en-GB': 'Max Drawdown',
        'it-IT': 'Max Drawdown',
      },
      mgmtFeeLabel: {
        'en-GB': 'Mgmt Fee',
        'it-IT': 'Mgmt Fee',
      },
      perfFeeLabel: {
        'en-GB': 'Performance Fee',
        'it-IT': 'Performance Fee',
      },
      isinLabel: {
        'en-GB': 'ISIN',
        'it-IT': 'ISIN',
      },
      nameLabel: {
        'en-GB': 'Name',
        'it-IT': 'Nome',
      },
    },
    // proposals.json compare
    compareProposals: {
      title: {
        'en-GB': 'Compare investments portfolios',
        'it-IT': 'Compara portfolio di investimento',
      },
      graphicSummary: {
        'en-GB': 'Graphic Summary',
        'it-IT': 'Graphic Summary',
      },
    },
    // accounts.json info
    accountInfos: {
      title: {
        'en-GB': "We're almost ready!<br/>Complete the information below to activate your account.",
        'it-IT':
          'Sei quasi pronto per investire!<br/>Completa le sezioni per accedere alla dashboard personale.',
      },
      description: {
        'en-GB':
          'Before you can start investing, we need to have all the right information in place. Please have your ID and Tax information ready.',
        'it-IT':
          'Per poter attivare il tuo account, dobbiamo completare e verificare le tue informazioni. Tieni a portata di mano i tuoi documenti e quelli dei beneficiari. Se hai bisogno di assistenza, il tuo Wealth Manager è a disposizione.',
      },
      viewContract: {
        'en-GB': 'View Contract',
        'it-IT': 'Visualizza Contratto',
      },
      backToAccountInfo: {
        'en-GB': 'Back to Account Information',
        'it-IT': 'Indietro ai Dati Account',
      },
      lastSteps: {
        'en-GB': 'The final steps before we get started!',
        'it-IT': 'Gli ultimi step prima di cominciare!',
      },
      lastStepsSubtext: {
        'en-GB':
          'Once your information will all be in place, we will perform a quick security check and your account will be ready to take off.',
        'it-IT':
          'Inserite le informazioni, potrai accedere al contratto e richiedere l’attivazione del tuo account.',
      },
      ppe: {
        title: {
          'en-GB': 'Identify Politically Exposed Person',
          'it-IT': 'Identifica Persona Politicamente Esposta',
        },
        warning: {
          'en-EN':
            'In the future you may be asked for additional information for investigations purposes.',
          'it-IT':
            'In futuro potrebbero esserti richieste ulteriori informazioni per accertamenti.',
        },
        politicallyExposedRelativeLabel: {
          'en-GB': 'Do you have family ties to a politically exposed person?',
          'it-IT': 'Hai legami di parentela con una persona politicamente esposta?',
        },
        politicallyExposedPersonLabel: {
          'en-EN':
            'Are you considered as a Politically Exposed Person, according to Article 1, letter dd) of Legislative Decree n. 90 of 25 May 2017?',
          'it-IT':
            "Sei considerabile come Persona Politicamente Esposta, ai sensi dell'Articolo 1, lettera dd) del D.lgs. n. 90 del 25 maggio 2017?",
        },
        goToLaw: {
          'en-EN': 'Go to Legislative Decree.',
          'it-IT': 'Vai al Decreto Legislativo.',
        },
        politicalOccupationLabel: {
          'en-GB': 'Role type',
          'it-IT': 'Tipologia di incarico',
        },
        politicallyExposedRelativeRelationshipLabel: {
          'en-EN': 'What is your relationship with the politically exposed person?',
          'it-IT': 'Qual è la tua relazione con la persona politicamente esposta?',
        },
        politicallyExposedRelativeOccupationLabel: {
          'en-EN': 'Role type of the politically exposed person',
          'it-IT': 'Tipologia di incarico della Persona Politicamente Esposta',
        },
        headsOfState: {
          'en-GB': 'Heads of state',
          'it-IT': 'Capi di Stato',
        },
        parliaments: {
          'en-GB': 'Members of parliaments',
          'it-IT': 'Parlamentari',
        },
        supremeCourt: {
          'en-GB': 'Members of supreme courts',
          'it-IT': 'Membri delle corti supreme',
        },
        ambassadors: {
          'en-GB': 'Ambassadors',
          'it-IT': 'Ambasciatori',
        },
        others: {
          'en-GB': 'Others',
          'it-IT': 'Altri',
        },
      },
      createPin: {
        title: {
          'en-GB': 'Create your PIN',
          'it-IT': 'Crea il tuo PIN',
        },
        description: {
          'en-GB':
            'Create your personal PIN code. It will be the code you will use as a signature to validate your operations on Qadra.',
          'it-IT':
            'Crea il tuo codice PIN personale. Sarà il codice che utilizzerai come firma per validare le tue operazioni su Qadra.',
        },
        titleConfirm: {
          'en-GB': 'Confirm your PIN',
          'it-IT': 'Conferma il tuo PIN',
        },
        descriptionConfirm: {
          'en-GB': 'Enter your PIN again.',
          'it-IT': 'Inserisci nuovamente il tuo PIN.',
        },
        differentPins: {
          'en-GB': 'The PINs entered are different!',
          'it-IT': 'I PIN inseriti sono diversi!',
        },
      },
    },
    // others.json contract
    contract: {
      title: {
        'en-GB': 'Contract',
        'it-IT': 'Contratto',
      },
      description: {
        'en-GB':
          'Read and sign the contract to activate your account.<br/>To get any clarification do not hesitate to contact your advisor.',
        'it-IT':
          'Leggi e firma il contratto per attivare il tuo account.<br/>Per ottenere qualsiasi chiarimento non esitare a contattare il tuo advisor.',
      },
      signContract: {
        'en-GB': 'Sign Contract',
        'it-IT': 'Firma Contratto',
      },
    },
    // modals.json
    modals: {
      insertPin: {
        title: {
          'en-GB': 'Insert your PIN',
          'it-IT': 'Inserisci il tuo PIN',
        },
        description: {
          'en-GB': 'Enter your PIN to confirm.',
          'it-IT': 'Inserisci il tuo PIN per confermare.',
        },
      },
      acceptProposal: {
        title: {
          'en-GB': 'Select Proposal',
          'it-IT': 'Seleziona Proposta',
        },
        description: {
          'en-GB': 'Please choose confirm to select this proposal.',
          'it-IT': 'Scegli conferma per selezionare questa proposta.',
        },
        warning: {
          'en-GB':
            'By accepting this self-generated proposal you will not receive the personalized proposal that the Wealth Manager is processing for you. Are you sure you want to proceed?',
          'it-IT':
            'Accettando questa proposta autogenerata non riceverai la proposta personalizzata che il Wealth Manager sta elaborando per te. Sei sicuro di voler procedere?',
        },
      },
      walletDeposit: {
        title: {
          'en-GB': 'Deposit',
          'it-IT': 'Effettua deposito',
        },
        description: {
          'en-GB':
            'Make a transfer using these bank details to deposit into your Wallet. Once the transfer is confirmed you will be notified and then you can start investing with Qadra.',
          'it-IT':
            'Fai un bonifico utilizzando queste coordinate bancarie per effettuare un deposito nel Wallet. Una volta concluso il deposito verrai avvisato e potrai iniziare ad investire con Qadra.',
        },
        fakeButton: {
          'en-GB': 'Make bank transfer',
          'it-IT': 'Esegui bonifico',
        },
        iban: {
          'en-GB': 'IBAN',
          'it-IT': 'IBAN',
        },
        causal: {
          'en-GB': 'Causal',
          'it-IT': 'Causale',
        },
        bicSwift: {
          'en-GB': 'BIC/SWIFT',
          'it-IT': 'BIC/SWIFT',
        },
      },
      walletWithdraw: {
        title: {
          'en-GB': 'Request bank transfer',
          'it-IT': 'Disponi bonifico',
        },
        description: {
          'en-GB': 'Enter the account details where you want to receive the amount.',
          'it-IT': "Inserisci i dati del conto dove vuoi ricevere l'importo scelto.",
        },
        fakeButton: {
          'en-GB': 'Make bank transfer',
          'it-IT': 'Esegui bonifico',
        },
        amountToWithdraw: {
          'en-GB': 'Amount to withdraw in €',
          'it-IT': 'Importo da prelevare in €',
        },
        accountHolder: {
          'en-GB': 'Account holder',
          'it-IT': 'Intestatario',
        },
        swiftCode: {
          'en-GB': 'SWIFT Code',
          'it-IT': 'Codice SWIFT',
        },
        titleRequest: {
          'en-GB': 'Withdraw request successfully sent!',
          'it-IT': 'Richiesta di prelievo inviata con successo!',
        },
        descriptionRequest: {
          'en-GB':
            'We have detected the withdrawal of the chosen amount. You will receive a notification upon completion.',
          'it-IT':
            'Abbiamo preso in carico il prelievo dell’importo scelto. Verrai notificato quando l’operazione verrà completata.',
        },
      },
      portfolioTransfer: {
        titleDeposit: {
          'en-GB': 'Invest with Qadra',
          'it-IT': 'Investi con Qadra',
        },
        descriptionDeposit: {
          'en-GB': 'Enter the amount to be transferred from your Wallet to your Portfolio.',
          'it-IT': "Inserisci l'importo da trasferire dal Wallet al Portfolio.",
        },
        titleDepositRequest: {
          'en-GB': 'Investment request successfully sent!',
          'it-IT': 'Richiesta di investimento inviata con successo!',
        },
        descriptionDepositRequest: {
          'en-GB':
            'We are processing your investment. You will receive a notification upon completion.',
          'it-IT':
            "Abbiamo preso in carico il tuo investimento. Verrai notificato quando l'operazione verrà completata.",
        },
        titleWithdraw: {
          'en-GB': 'Liquidate Portfolio',
          'it-IT': 'Liquida Portfolio',
        },
        descriptionWithdraw: {
          'en-GB': 'Enter the amount to be transferred from your Portfolio to your Wallet.',
          'it-IT': "Inserisci l'importo da trasferire dal Portfolio al Wallet.",
        },
        titleWithdrawRequest: {
          'en-GB': 'Liquidation request successfully sent!',
          'it-IT': 'Richiesta di liquidazione inviata con successo!',
        },
        descriptionWithdrawRequest: {
          'en-GB':
            'We took charge of the liquidation of the chosen amount. You will receive a notification upon completion.',
          'it-IT':
            "Abbiamo preso in carico la liquidazione dell'importo scelto. Verrai notificato quando l'operazione verrà completata.",
        },
        portfolio: {
          'en-GB': 'Portfolio',
          'it-IT': 'Portfolio',
        },
        amount: {
          'en-GB': 'Amount in €',
          'it-IT': 'Valore in €',
        },
        maxAmount: {
          'en-GB': 'Maximum transfer value',
          'it-IT': 'Valore massimo transferibile',
        },
        maxAmountExceeded: {
          'en-GB': 'You cannot tranfer that much!',
          'it-IT': 'Non puoi transferire così tanto!',
        },
      },
    },
    // others.json
    walletClient: {
      placeholderText: {
        'en-GB':
          'You can use the Wallet to manage your investments when your account is activated.',
        'it-IT':
          'Potrai utilizzare il Wallet per gestire i tuoi invesimenti quando il tuo account verrà attivato.',
      },
    },
  },
  portfolios: {
    label: {
      'en-GB': 'Portfolios',
      'it-IT': 'Portfolio',
    },
    searchPlaceholder: {
      'en-GB': 'Search portfolios by ID, name or owner',
      'it-IT': 'Ricerca portfolio per ID, nome o intestatario',
    },
  },
  fundSelectionTool: {
    title: {
      'en-GB': 'Fund Selection Tool',
      'it-IT': 'Fund Selection Tool',
    },
  },
  optimizationTool: {
    title: {
      'en-GB': 'Optimization Tool',
      'it-IT': 'Optimization Tool',
    },
  },
  // statuses.json
  clusteringTool: {
    title: {
      'en-GB': 'Clustering Tool',
      'it-IT': 'Clustering Tool',
    },
    preProcessing: {
      'en-GB': 'Pre-processing',
      'it-IT': 'Pre-processing',
    },
    preProcessingProfile: {
      'en-GB': 'Pre-processing profile',
      'it-IT': 'Profilo di pre-processing',
    },
    assets: {
      'en-GB': 'Assets',
      'it-IT': 'Asset',
    },
    classes: {
      'en-GB': 'Classes',
      'it-IT': 'Classi',
    },
    clearFilters: {
      'en-GB': 'Clear Filters',
      'it-IT': 'Rimuovi Filtri',
    },
    colorBy: {
      'en-GB': 'Color by',
      'it-IT': 'Colora per',
    },
    axisX: {
      'en-GB': 'Axis X value',
      'it-IT': 'Valore asse X',
    },
    axisY: {
      'en-GB': 'Axis Y value',
      'it-IT': 'Valore asse Y',
    },
    titles: {
      'en-GB': 'Titles',
      'it-IT': 'Titoli',
    },
    selected: {
      'en-GB': 'Selected',
      'it-IT': 'Selezionati',
    },
    hide: {
      'en-GB': 'Hide',
      'it-IT': 'Nascondi',
    },
    showAll: {
      'en-GB': 'Show All',
      'it-IT': 'Mostra Tutti',
    },
    removeSelected: {
      'en-GB': 'Remove Selected',
      'it-IT': 'Rimuovi Selezionati',
    },
    downloadCSV: {
      'en-GB': 'Download CSV',
      'it-IT': 'Scarica CSV',
    },
    numberOfCLusters: {
      'en-GB': 'Number of clusters',
      'it-IT': 'Numero di cluster',
    },
    calcProfile: {
      'en-GB': 'Calculate profile',
      'it-IT': 'Calcola profilo',
    },
    peersProfile: {
      'en-GB': 'Peers profile',
      'it-IT': 'Profilo di peers',
    },
    placeholderSelect: {
      'en-GB': 'Search by name or ISIN',
      'it-IT': 'Ricerca per nome o ISIN',
    },
  },
  peerCategories: {
    searchInstrumentPlaceholder: {
      'en-GB': 'Search instruments by name or ISIN',
      'it-IT': 'Cerca titoli con nome o ISIN',
    },
    backToHome: {
      'en-GB': 'Back to Peers',
      'it-IT': 'Torna a Peer',
    },
  },
  accountStatus: {
    Created: {
      'en-GB': 'Created',
      'it-IT': 'Creato',
    },
    Profiled: {
      'en-GB': 'Profiled',
      'it-IT': 'Profilato',
    },
    AcceptedProposal: {
      'en-GB': 'Accepted Proposal',
      'it-IT': 'Proposta Accettata',
    },
    SignedContract: {
      'en-GB': 'Signed Contract',
      'it-IT': 'Contratto Firmato',
    },
    Active: {
      'en-GB': 'Active',
      'it-IT': 'Attivo',
    },
    Financed: {
      'en-GB': 'Financed',
      'it-IT': 'Finanziato',
    },
    Suspended: {
      'en-GB': 'Suspended',
      'it-IT': 'Sospeso',
    },
  },
  userStatus: {
    Lead: {
      'en-GB': 'Lead',
      'it-IT': 'Lead',
    },
    Profiled: {
      'en-GB': 'Profiled',
      'it-IT': 'Profilato',
    },
    Verified: {
      'en-GB': 'Verified',
      'it-IT': 'Verificato',
    },
    Active: {
      'en-GB': 'Active',
      'it-IT': 'Attivo',
    },
    Deleted: {
      'en-GB': 'Deleted',
      'it-IT': 'Cancellato',
    },
  },
  portfolioStatus: {
    Created: {
      'en-GB': 'Created',
      'it-IT': 'Creato',
    },
    Financed: {
      'en-GB': 'Financed',
      'it-IT': 'Finanziato',
    },
    OnTrack: {
      'en-GB': 'On Track',
      'it-IT': 'On Track',
    },
    OffTrack: {
      'en-GB': 'Off Track',
      'it-IT': 'Off Track',
    },
  },
  leadStatus: {
    New: {
      'en-GB': 'New',
      'it-IT': 'Nuovo',
    },
    InProgress: {
      'en-GB': 'In Progress',
      'it-IT': 'In Corso',
    },
    Connected: {
      'en-GB': 'Converted',
      'it-IT': 'Convertito',
    },
    Unqualified: {
      'en-GB': 'Unqualified',
      'it-IT': 'Non Qualificato',
    },
  },
  // dashboard_wm.json
  dashboardFa: {
    copyInviteLink: {
      'en-GB': 'Copy and share your invitation link to Qadra',
      'it-IT': "Copia e condividi il tuo link d'invito a Qadra",
    },
    placeholderText: {
      'en-GB':
        'You will be able to view the complete dashboard when you have at least one client with an active portfolio.',
      'it-IT':
        'Potrai visualizzare la dashboard completa quando avrai almeno un cliente con un portfolio attivo.',
    },
    feeYtd: {
      'en-GB': 'Fee - Year to Date',
      'it-IT': 'Fee - Year to Date',
    },
    lastMonthFee: {
      'en-GB': 'Last month Fee',
      'it-IT': 'Fee ultimo mese',
    },
    assetsUnderManagement: {
      'en-GB': 'Assets Under Management',
      'it-IT': 'Asset Under Management',
    },
    lastMonthGrowth: {
      'en-GB': 'Last month growth',
      'it-IT': 'Crescita ultimo mese',
    },
    lastQuarterGrowth: {
      'en-GB': 'Last quarter growth',
      'it-IT': 'Crescita ultimo trimestre',
    },
    portfolioMean: {
      'en-GB': 'Average portfolio value',
      'it-IT': 'Valore portfolio medio',
    },
    portfoliosStatus: {
      'en-GB': 'Portfolios Status',
      'it-IT': 'Stato Portfolio',
    },
    accountsStatus: {
      'en-GB': 'Accounts Status',
      'it-IT': 'Account per stato',
    },
    accountsVolume: {
      'en-GB': 'Accounts Volume',
      'it-IT': 'Account per volume',
    },
    accountsStrategy: {
      'en-GB': 'Accounts Strategy',
      'it-IT': 'Strategia Account',
    },
    accountsMifid: {
      'en-GB': 'Accounts MiFID',
      'it-IT': 'Account per MiFID',
    },
    accountVolumeLevels: [
      {
        'en-GB': 'From 1 to 50K',
        'it-IT': 'Da 1 a 50K',
      },
      {
        'en-GB': 'From 50K to 100K',
        'it-IT': 'Da 50K a 100K',
      },
      {
        'en-GB': 'From 100K to 200K',
        'it-IT': 'Da 100K a 200K',
      },
      {
        'en-GB': 'From 200K to 500K',
        'it-IT': 'Da 200K a 500K',
      },
      {
        'en-GB': 'From 500K to 1M',
        'it-IT': 'Da 500K a 1M',
      },
      {
        'en-GB': 'More than 1M',
        'it-IT': 'Più di 1M',
      },
    ],
  },
  // dashboard_wm.json
  dashboardClient: {
    notYetActivatedAlertTitle: {
      'en-GB': 'Your account is pending verification.',
      'it-IT': 'Il tuo account è in corso di attivazione.',
    },
    notYetActivatedAlertText: {
      'en-GB':
        'We are verifying the information you provided and will be back soon. In the meantime, you can reach out to your Wealth Manager for any question you may have!',
      'it-IT':
        'Stiamo verificando i dati che ci hai fornito e saremo di nuovo da te a breve. Nel frattempo, il tuo Wealth Manager è tua disposizione per qualsiasi dubbio o domanda!',
    },
    activeAlertTitle: {
      'en-GB': 'Your account is now active. Now you can start investing with Qadra!',
      'it-IT': 'Il tuo account è stato attivato. Ora puoi iniziare ad investire con Qadra!',
    },
    financedAlertTitle: {
      'en-GB': 'Invest with Qadra in your goals.',
      'it-IT': 'Investi con Qadra nei tuoi obiettivi.',
    },
    totalNav: {
      'en-GB': 'Current value of your Qadra portfolio',
      'it-IT': 'Valore attuale del portafoglio Qadra',
    },
    totalInvestedAmount: {
      'en-GB': 'Your investment',
      'it-IT': 'Quanto hai investito',
    },
    totalReturn: {
      'en-GB': 'Gross return',
      'it-IT': 'Quanto hai guadagnato',
    },
    totalFees: {
      'en-GB': 'Qadra fees',
      'it-IT': 'Commissioni Qadra',
    },
    totalNetReturn: {
      'en-GB': 'Net return',
      'it-IT': 'Guadagno netto',
    },
    performanceTitle: {
      'en-GB': 'Performance',
      'it-IT': 'Conto economico',
    },
    investmentsTitle: {
      'en-GB': 'My investments with Qadra',
      'it-IT': 'Gli investimenti del mio piano finanziario',
    },
    successfulDeposit: {
      'en-EN': [
        'Your deposit was successfully received. Now you can use it to',
        'invest with Qadra.',
      ],
      'it-IT': [
        'Il tuo deposito è avvenuto con successo. Adesso puoi usarlo per',
        'investire con Qadra.',
      ],
    },
    totalWealthProjection: {
      'en-GB': 'Total Wealth Projection',
      'it-IT': 'Total Wealth Proiezione',
    },
    toBeFunded: {
      'en-GB': 'To Be Funded',
      'it-IT': 'Da Finanziare',
    },
    netWealth: {
      'en-GB': 'Net Wealth',
      'it-IT': 'Patrimonio Netto',
    },
    ytdGrowth: {
      'en-GB': 'Year-To-Date Growth',
      'it-IT': 'Crescita Year-To-Date',
    },
    portfolioProposal: {
      'en-GB': 'Portfolio proposal',
      'it-IT': 'Proposta portfolio',
    },
  },
  // tooltips.json
  tooltips: {
    passwordRules: {
      title: {
        'en-GB': 'Password Rules',
        'it-IT': 'Regole Password',
      },
      description: {
        'en-GB':
          'The password must contain:<ul><li>minimum 8 characters</li><li>at least 1 uppercase letter</li><li>at least 1 lowercase letter</li><li>at least 1 number</li><li>at least 1 special character</li></ul>',
        'it-IT':
          'La password deve contenere:<ul><li>minimo 8 caratteri</li><li>almeno 1 lettera maiuscola</li><li>almeno 1 lettera minuscola</li><li>almeno 1 numero</li><li>almeno 1 carattere speciale</li></ul>',
      },
    },
    etf: {
      title: {
        'en-GB': 'Exchanged Traded Fund',
        'it-IT': 'Exchanged Traded Fund',
      },
      description: {
        'en-GB':
          'An exchange-traded fund (ETF) is a type of security that involves a collection of securities—such as stocks—that often tracks an underlying index, although they can invest in any number of industry sectors or use various strategies. ETFs are in many ways similar to mutual funds; however, they are listed on exchanges and ETF shares trade throughout the day just like ordinary stock.<br/><br/>Source: investopedia.com',
        'it-IT':
          "Particolare tipologia di fondo d'investimento o Sicav con due principali caratteristiche: 1. è negoziato in Borsa come un'azione; 2. ha come unico obiettivo d'investimento quello di replicare l'indice al quale si riferisce (benchmark) attraverso una gestione totalmente passiva.<br/><br/>Fonte: borsaitaliana.it",
      },
    },
    financialLiabilities: {
      title: {
        'en-GB': 'Financial Liabilities',
        'it-IT': 'Passività Finanziarie',
      },
      description: {
        'en-GB':
          'Liabilities can be described as an obligation between one party and another that has not yet been completed or paid for.<br/><br/>Source: investopedia.com',
        'it-IT':
          'In senso concr., gli elementi passivi (debiti, ecc.) di un soggetto economico; si distinguono p. a breve termine (per finanziare le spese correnti) e p. a lungo termine (per finanziare investimenti).<br/><br/>Fonte: treccani.it',
      },
    },
    nav: {
      title: {
        'en-GB': 'Net Asset Value',
        'it-IT': 'Net Asset Value',
      },
      description: {
        'en-GB':
          'The Net Asset Value represents the net value of an entity and is calculated as the total value of the entity’s assets minus the total value of its liabilities.<br/><br/>Source: investopedia.com',
        'it-IT':
          'Il Net Asset Value è il rapporto tra la somma dei valori di mercato delle attività del portafoglio di un fondo comune di investimento e il numero di quote in circolazione.<br/><br/>Source: borsaitaliana.it',
      },
    },
    mgmtFee: {
      title: {
        'en-GB': 'Management Fee',
        'it-IT': 'Management Fee',
      },
      description: {
        'en-GB':
          "Management Fee is calculated as a % of a portfolio's size (0.3% to 1%), on a monthly basis, and charged monthly.",
        'it-IT':
          'La Management Fee è calcolata in % della dimensione del portafoglio (da 0,3% a 1%), su base mensile, e addebitata mensilmente.',
      },
    },
    perfFee: {
      title: {
        'en-GB': 'Performance Fee',
        'it-IT': 'Performance Fee',
      },
      description: {
        'en-GB':
          'Performance Fee is 20% of the gross gain of a certain portfolio at the end of the year. For example, if you have invested 100, and at the end of the year your portfolio is worth 110 (with a gain of 10), you will be charged 2.',
        'it-IT':
          "La Performance Fee è pari al 20% della plusvalenza lorda di un certo portafoglio a fine anno. Ad esempio, se hai investito 100, e alla fine dell'anno il tuo portafoglio ne vale 110 (con un guadagno di 10), ti verrà addebitato 2.",
      },
    },
    maxDrawdown: {
      title: {
        'en-GB': 'Max Drawdown',
        'it-IT': 'Max Drawdown',
      },
      description: {
        'en-GB':
          'A maximum drawdown (MDD) is the maximum observed loss from a peak to a trough of a portfolio, before a new peak is attained. Maximum drawdown is an indicator of downside risk over a specified time period.<br/><br/>Source: investopedia.com',
        'it-IT':
          'È un indicatore di rischio dello strumento finanziario e rappresenta la perdita massima maturata, nel periodo di analisi, rispetto al valore di picco registrato. Il periodo per recuperare la perdita indica invece il numero di mesi che sono stati necessari, nel periodo di analisi, per riportare il valore dello strumento finanziario dal minimo al valore di picco iniziale.<br/><br/>Fonte: morningstar.it',
      },
    },
    timeToRecovery: {
      title: {
        'en-GB': 'Time to Recovery',
        'it-IT': 'Time to Recovery',
      },
      description: {
        'en-GB':
          'Time to Recovery (TTR) is the time it takes for a certain portfolio to recover the losses generated at the time of Max Drawdown',
        'it-IT':
          'Il Time to Recovery (TTR) è il tempo che un certo portafoglio impiega per recuperare le perdite generate nel momento di Max Drawdown',
      },
    },
    returnAnnualized: {
      title: {
        'en-GB': 'Annualized return',
        'it-IT': 'Rendimento annualizzato',
      },
      description: {
        'en-GB':
          'An annualized total return is the geometric average amount of money earned by an investment each year over a given time period. The annualized return formula is calculated as a geometric average to show what an investor would earn over a period of time if the annual return was compounded.<br/><br/>Source: investopedia.com',
        'it-IT':
          "Per rendere confrontabili performance calcolate su orizzonti temporali di durata diversa, è possibile convertirne il valore su una base temporale comune, in genere pari all'anno. Questo calcolo può essere effettuato avvalendosi di un regime a capitalizzazione semplice o di uno a capitalizzazione composta.<br/><br/>Fonte: morningstar.it",
      },
    },
    annualizedReturn: {
      title: {
        'en-GB': 'Annualized return',
        'it-IT': 'Rendimento annualizzato',
      },
      description: {
        'en-GB':
          'An annualized total return is the geometric average amount of money earned by an investment each year over a given time period. The annualized return formula is calculated as a geometric average to show what an investor would earn over a period of time if the annual return was compounded.<br/><br/>Source: investopedia.com',
        'it-IT':
          "Per rendere confrontabili performance calcolate su orizzonti temporali di durata diversa, è possibile convertirne il valore su una base temporale comune, in genere pari all'anno. Questo calcolo può essere effettuato avvalendosi di un regime a capitalizzazione semplice o di uno a capitalizzazione composta.<br/><br/>Fonte: morningstar.it",
      },
    },
    volatility: {
      title: {
        'en-GB': 'Volatility',
        'it-IT': 'Volatilità',
      },
      description: {
        'en-GB':
          'Volatility is a statistical measure of the dispersion of returns for a given security or market index. In most cases, the higher the volatility, the riskier the security. Volatility is often measured as either the standard deviation or variance between returns from that same security or market index. <br/><br/>Source: investopedia.com',
        'it-IT':
          "La volatilità misura l'incertezza circa i futuri movimenti del prezzo di un bene o di una attività finanziaria. Al crescere della volatilità cresce la probabilità che la performance risulti molto elevata oppure molto contenuta, ossia cresce la probabilità che i movimenti di prezzo siano molto ampi, sia in aumento che in diminuzione. <br/><br/>Fonte: borsaitaliana.it",
      },
    },
    var: {
      title: {
        'en-GB': 'Value at Risk (VaR)',
        'it-IT': 'Value at Risk (VaR)',
      },
      description: {
        'en-GB':
          'Value at risk (VaR) is a statistic that measures and quantifies the level of financial risk within a firm, portfolio or position over a specific time frame. This metric is most commonly used by investment and commercial banks to determine the extent and occurrence ratio of potential losses in their institutional portfolios. <br/><br/>Source: investopedia.com',
        'it-IT':
          'Il Value at Risk (VaR) è una misura del rischio di mercato associato ad un’attività finanziaria. Esso rappresenta, su un dato orizzonte temporale (solitamente pari ad 1 giorno o a 10 giorni) e con un dato livello di probabilità o confidenza statistica (solitamente pari al 95% o al 99%), la perdita massima ipotizzabile derivante dalla detenzione dell’attività finanziaria oggetto di valutazione. <br/><br/>Fonte: borsaitaliana.it',
      },
    },
    'Qars 10%': {
      title: {
        'en-GB': 'Qars 10%',
        'it-IT': 'Qars 10%',
      },
      description: {
        'en-GB':
          'Qars 10% is the most prudential (2% target VAR) version of QARS, our absolute-return quantitative strategy. It has a maximum exposure to equity markets of 10% of the overall assets and average target return of 3% with 12 months holding period.',
        'it-IT':
          "Qars 10% è la versione più prudente (2% target VAR) di QARS, la nostra strategia quantitativa di ritorno assoluto. Ha un'esposizione massima ai mercati azionari del 10% del patrimonio complessivo e un rendimento medio previsto del 3% su un periodo di detenzione di 12 mesi.",
      },
    },
    'Qars 25%': {
      title: {
        'en-GB': 'Qars 25%',
        'it-IT': 'Qars 25%',
      },
      description: {
        'en-GB':
          'Qars 25% is a medium low risk (3% target VAR) version of QARS, our absolute-return quantitative strategy. It has a maximum exposure to equity markets of 25% of the overall assets and average target return 5% with 12 to 18 months holding period.',
        'it-IT':
          "Qars 25% è una versione con medio basso rischio (3% target VAR) di QARS, la nostra strategia quantitativa di ritorno assoluto. Ha un'esposizione massima ai mercati azionari del 25% del patrimonio complessivo e un rendimento medio previsto del 5% su un periodo di detenzione da 12 a 18 mesi.",
      },
    },
    'Qars 45%': {
      title: {
        'en-GB': 'Qars 45%',
        'it-IT': 'Qars 45%',
      },
      description: {
        'en-GB':
          'Qars 45% is a medium risk (5.5% target VAR) version of QARS, our absolute-return quantitative strategy. It has a maximum exposure to equity markets of 45% of the overall assets and average target return 9% with 12 to 18 months holding period.',
        'it-IT':
          "Qars 45% è una versione con medio rischio (5.5% target VAR) di QARS, la nostra strategia quantitativa di ritorno assoluto. Ha un'esposizione massima ai mercati azionari del 45% del patrimonio complessivo e un rendimento medio previsto del 9% su un periodo di detenzione da 12 a 18 mesi.",
      },
    },
    'Qars 75%': {
      title: {
        'en-GB': 'Qars 75%',
        'it-IT': 'Qars 75%',
      },
      description: {
        'en-GB':
          'Qars 75% is a medium high risk (7.5% target VAR) version of QARS, our absolute-return quantitative strategy. It has a maximum exposure to equity markets of 75% of the overall assets and average target return 14% with 18 to 24 months holding period.',
        'it-IT':
          "Qars 75% è una versione con medio alto rischio (7.5% target VAR) di QARS, la nostra strategia quantitativa di ritorno assoluto. Ha un'esposizione massima ai mercati azionari del 75% del patrimonio complessivo e un rendimento medio previsto del 14% su un periodo di detenzione da 18 a 24 mesi.",
      },
    },
    'Qars 100%': {
      title: {
        'en-GB': 'Qars 100%',
        'it-IT': 'Qars 100%',
      },
      description: {
        'en-GB':
          'Qars 100% is the most bold (8.5% target VAR) version of QARS, our absolute-return quantitative strategy. It has an exposure to equity markets up to 100% of the overall assets and average target return 18% with 24 months holding period.',
        'it-IT':
          "Qars 100% è la versione più ambiziosa (8.5% target VAR) di QARS, la nostra strategia quantitativa di ritorno assoluto. Ha un'esposizione massima ai mercati azionari del 100% del patrimonio complessivo e un rendimento medio previsto del 18% su un periodo di detenzione di 24 mesi.",
      },
    },
    mixedBenchmark: {
      title: {
        'en-GB': 'Mixed Benchmark',
        'it-IT': 'Mixed Benchmark',
      },
      description: {
        'en-GB':
          'Mixed benchmark is a index compound by Bloomberg Barclays EUR Aggregate (euro bonds index) and MSCI All-Country World Equity Index (world stocks index).',
        'it-IT':
          'Il Mixed Benchmark è un indice composto da Bloomberg Barclays EUR Aggregate (indice obbligazionario in euro) e MSCI All-Country World Equity Index (indice azionario mondiale).',
      },
    },
  },
  // others.json
  clientsSection: {
    details: {
      allowOnboardingWarning: {
        'en-GB':
          'This profile required your help for onboarding. Click on "Complete Onboarding" to complete it.',
        'it-IT':
          'Questo profilo ha richiesto il tuo intervento per l\'onboarding. Clicca su "Completa Onboarding" per completarlo.',
      },
      completeOnboarding: {
        'en-GB': 'Complete Onboarding',
        'it-IT': 'Completa Onboarding',
      },
      backToClients: {
        'en-GB': 'Back to Clients',
        'it-IT': 'Torna a Clienti',
      },
    },
  },
  // others.json
  mandatesSection: {
    changeMandate: {
      'en-GB': 'Change Mandate',
      'it-IT': 'Modifica Linea di Gestione',
    },
    addToMandate: {
      'en-GB': 'Add to Mandate',
      'it-IT': 'Aggiungi a Linea di Gestione',
    },
    createMandate: {
      'en-GB': 'Create Mandate',
      'it-IT': 'Crea Linea di Gestione',
    },
    backToMandates: {
      'en-GB': 'Back to Mandates',
      'it-IT': 'Torna a Linee di Gestione',
    },
    backToMandate: {
      'en-GB': 'Back to Mandate',
      'it-IT': 'Torna alla Linea di Gestione',
    },
    optimizeMandate: {
      'en-GB': 'Mandate Optimization',
      'it-IT': 'Ottimizzazione Linea di Gestione',
    },
    setMandatesInstruments: {
      'en-GB': 'Sets the assets of the mandate to observe the details',
      'it-IT': 'Imposta gli asset della linea di gestione per osservarne i dettagli',
    },
    leavingPageMessage: {
      'en-GB': 'Are you sure you want to leave this page? Every change will be lost.',
      'it-IT': 'Sei sicuro di voler lasciare questa pagina? Ogni modifica verrà persa.',
    },
    importQuotesRefresh: {
      'en-GB':
        'The quotes were imported successfully, you will be able to see the changes in a few minutes.',
      'it-IT':
        'Le serie storiche sono state importate con successo, potrai vedere i cambiamenti in pochi minuti.',
    },
    uploadQuotes: {
      'en-GB': 'Upload Quotes',
      'it-IT': 'Carica Serie Storiche',
    },
    selectQuotes: {
      'en-GB': 'Select Quotes',
      'it-IT': 'Seleziona Serie Storiche',
    },
  },
  walletTransactionType: {
    Withdraw: {
      'en-GB': 'Withdraw',
      'it-IT': 'Prelievo',
    },
    Deposit: {
      'en-GB': 'Deposit',
      'it-IT': 'Deposito',
    },
    PortfolioWithdraw: {
      'en-GB': 'Portfolio Withdraw',
      'it-IT': 'Prelievo Portfolio',
    },
    PortfolioDeposit: {
      'en-GB': 'Portfolio Deposit',
      'it-IT': 'Deposito Portfolio',
    },
    ManagementFee: {
      'en-GB': 'Management Fee',
      'it-IT': 'Management Fee',
    },
  },
  // models.json
  modelPortfolios: {
    'en-GB': 'Models',
    'it-IT': 'Modelli',
  },
  modelPortfoliosSection: {
    optimizationSuccessful: {
      'en-GB': 'Successful optimization! If you are satisfied with the model proceed to save it.',
      'it-IT':
        'Ottimizzazione riuscita! Se sei soddisfatto del modello procedi con il salvataggio.',
    },
    fundSelectionToolSuccessful: {
      'en-GB': 'New funds added! Remember to optimize the model.',
      'it-IT': 'Nuovi fondi aggiunti! Ricordati di ottimizzare il modello.',
    },
    optimizeModel: {
      'en-GB': 'Model Optimization',
      'it-IT': 'Ottimizzazione Modello',
    },
    addToModel: {
      'en-GB': 'Add to Model',
      'it-IT': 'Aggiungi a Modello',
    },
    backToModel: {
      'en-GB': 'Back to Model',
      'it-IT': 'Torna al Modello',
    },
    backToModels: {
      'en-GB': 'Back to Models',
      'it-IT': 'Torna a Modelli',
    },
    createModel: {
      'en-GB': 'Create Model',
      'it-IT': 'Crea Modello',
    },
    changeModel: {
      'en-GB': 'Change Model',
      'it-IT': 'Cambia Modello',
    },
    searchPlaceholder: {
      'en-GB': 'Search models by name',
      'it-IT': 'Cerca modelli con nome',
    },
    placeholderOptimizationText: {
      'en-GB': 'Set the parameters for optimization to have a rebalanced model.',
      'it-IT': 'Imposta i parametri per l’ottimizzazione per avere un modello ribilanciata.',
    },
    runOptimization: {
      'en-GB': 'Optimize Model',
      'it-IT': 'Ottimizza Modello',
    },
    modelLink: {
      'en-GB': 'Share Model Link',
      'it-IT': 'Condividi Link del Modello',
    },
    setModelInstruments: {
      'en-GB': 'Sets the assets of the model to observe the details',
      'it-IT': 'Imposta gli asset del modello per osservarne i dettagli',
    },
    deleteModels: {
      'en-GB': 'Delete Models',
      'it-IT': 'Cancella Modelli',
    },
    deleteConfirm: {
      'en-GB': 'Are you sure you want to delete the following Models?',
      'it-IT': 'Sei sicuro di volere cancellare i seguenti Modelli?',
    },
    modelRiskProfile: {
      'en-GB': 'This model risk profile is',
      'it-IT': 'Il profilo di rischio di questo modello è',
    },
    managementFeeDescription: {
      'it-IT':
        'La commissione annuale per il capitale investito varia dall’1,25% al 0,5% in base alla dimensione del portafoglio e viene addebitata mensilmente.<br/><br/>Non è comprensiva d’IVA, pari al 22% della fattura mensile. Sono escluse anche le eventuali imposte e bolli statali a carico del cliente.',
      'en-GB':
        'The annual fee for the invested capital varies from 1.25% to 0.5% based on portfolio size and is debited monthly.<br/><br/>It does not include VAT, equal to 22% of the monthly invoice. Any taxes and state stamps charged to the customer are also excluded.',
    },
    performanceFeeDescription: {
      'it-IT':
        'La Performance Fee si applica sui rendimenti positivi e viene percepita su base annuale.<br/><br/>Viene calcolata con il metodo dell’High Watermark Assoluto, ciò significa che viene applicata solo se il valore del portafoglio è aumentato nel corso dell’anno e il valore raggiunto è superiore a quello più elevato mai raggiunto in precedenza.',
      'en-GB':
        'Performance Fee is based on positive returns and is early charged.<br/><br/>It is calculated using the Absolute High Watermark method, which means that it is applied only if the value of the portfolio has increased at the end of the year, and that the value is higher than the highest ever achieved before.',
    },
  },
  // optimization.json
  optimization: {
    label: {
      'en-GB': 'Optimization',
      'it-IT': 'Ottimizzazione',
    },
    backToOptimization: {
      'en-GB': 'Back to Optimization',
      'it-IT': "Torna all'Ottimizzazione",
    },
    compareOptimization: {
      'en-GB': 'Compare Optimization',
      'it-IT': 'Compara Ottimizzazione',
    },
    confirmChanges: {
      'en-GB': 'Confirm Changes',
      'it-IT': 'Conferma Modifica',
    },
    confirmSelection: {
      'en-GB': 'Confirm Selection',
      'it-IT': 'Conferma Selezione',
    },
    valueRangeWarning: {
      'en-GB': 'Values must be valid numbers with no more than two decimals.',
      'it-IT': 'I valori devono essere un numero valido con non più di due decimali.',
    },
    minGreaterThanMaxWarning: {
      'en-GB': 'Min is greater than max',
      'it-IT': 'Il valore minimo è più alto del massimo',
    },
    maxGreaterThanMaxRisk: {
      'en-GB': 'Max value is greater than max risk',
      'it-IT': 'Il valore massimo è più alto del massimo rischio',
    },
    minWeight: {
      'en-GB': 'Min weight',
      'it-IT': 'Peso min',
    },
    maxWeight: {
      'en-GB': 'Max weight',
      'it-IT': 'Peso max',
    },
    min: {
      'en-GB': 'Min',
      'it-IT': 'Min',
    },
    max: {
      'en-GB': 'Max',
      'it-IT': 'Max',
    },
    minVar: {
      'en-GB': 'Min VaR',
      'it-IT': 'VaR min',
    },
    maxVar: {
      'en-GB': 'Max VaR',
      'it-IT': 'VaR max',
    },
    optimizationCriteria: {
      'en-GB': 'Optimization criteria',
      'it-IT': 'Criteri di ottimizzazione',
    },
    optimizationObjectives: {
      'en-GB': 'Optimization objectives',
      'it-IT': "Obiettivi dell'ottimizzazione",
    },
    maxResults: {
      'en-GB': 'Max displayed results no.',
      'it-IT': 'Max risultati visualizzati n.',
    },
    positiveScenario: {
      'en-GB': 'Positive scenario',
      'it-IT': 'Scenario positivo',
    },
    historicalScenario: {
      'en-GB': 'Historical scenario',
      'it-IT': 'Scenario storico',
    },
    negativeScenario: {
      'en-GB': 'Negative scenario',
      'it-IT': 'Scenario negativo',
    },
    returnPositive: {
      'en-GB': 'Positive return',
      'it-IT': 'Rendimento positivo',
    },
    returnNegative: {
      'en-GB': 'Negative return',
      'it-IT': 'Rendimento negativo',
    },
    returnHist: {
      'en-GB': 'Historical return',
      'it-IT': 'Rendimento storica',
    },
    volatilityPositive: {
      'en-GB': 'Positive volatility',
      'it-IT': 'Volatilità positivo',
    },
    volatilityNegative: {
      'en-GB': 'Negative volatility',
      'it-IT': 'Volatilità negativo',
    },
    volatilityHist: {
      'en-GB': 'Historical volatility',
      'it-IT': 'Volatilità storica',
    },
    goalPositive: {
      'en-GB': 'Positive probability',
      'it-IT': 'Probabilità positivo',
    },
    goalNegative: {
      'en-GB': 'Negative probability',
      'it-IT': 'Probabilità negativo',
    },
    goalHist: {
      'en-GB': 'Historical probability',
      'it-IT': 'Probabilità storica',
    },
    sharpePositive: {
      'en-GB': 'Positive sharpe',
      'it-IT': 'Sharpe positivo',
    },
    sharpeNegative: {
      'en-GB': 'Negative sharpe',
      'it-IT': 'Sharpe negativo',
    },
    sharpeHist: {
      'en-GB': 'Historical sharpe',
      'it-IT': 'Sharpe storica',
    },
    selectParameterPlaceholder: {
      'en-GB': 'Select a parameter',
      'it-IT': 'Seleziona un parametro',
    },
    var: {
      'en-GB': 'VaR',
      'it-IT': 'VaR',
    },
    maxDrawdown: {
      'en-GB': 'Max Drawdown',
      'it-IT': 'Max Drawdown',
    },
    maxDrawdownTooltip: {
      'en-GB': '',
      'it-IT': '',
    },
    targetReturn: {
      'en-GB': 'Target Return',
      'it-IT': 'Rendimento Atteso',
    },
    targetReturnDescription: {
      'en-GB':
        'It represents the probability of having a return greater than the target return on that scenario.',
      'it-IT':
        'Rappresenta la probabilità di avere un rendimento maggiore del rendimento atteso nel singolo scenario.',
    },
    criteriaDescription: {
      'en-GB':
        'Select for which assets you want to optimize the proposal, with the relative minimum and/or maximum weight.',
      'it-IT':
        'Seleziona per quali asset vuoi ottimizzare la proposta, con il relativo peso minimo e/o massimo.',
    },
    selectPlaceholder: {
      'en-GB': 'Select an asset',
      'it-IT': 'Seleziona un asset',
    },
  },
  // leads.json
  leadsSection: {
    createLead: {
      'en-GB': 'Create Lead',
      'it-IT': 'Crea Lead',
    },
    createLeadConfirmPolicy: {
      'en-GB':
        'I confirm that I have received permission from the customer to register and use the following data.',
      'it-IT':
        'Confermo di aver ricevuto l’autorizzazione dal cliente per la registrazione e l’utilizzo dei seguenti dati.',
    },
    searchPlaceholder: {
      'en-GB': 'Search leads by name or email',
      'it-IT': 'Ricerca portfolio per nome o email',
    },
    newLeadsAlert: {
      'en-GB': 'You have {0} new leads',
      'it-IT': 'Hai {0} nuovi lead',
    },
    backToLeads: {
      'en-GB': 'Back to Leads',
      'it-IT': 'Torna ai Lead',
    },
    refreshWarning: {
      'en-GB':
        'The lead is being created, it may take a few seconds. Refresh the page to check it out.',
      'it-IT':
        'Il lead è in fase di creazione, potrebbe metterci qualche secondo. Refresha la pagina per controllare.',
    },
  },
  contactPopup: {
    labelFa: {
      'en-GB': 'Contact your Wealth Manager',
      'it-IT': 'Contatta il tuo Wealth Manager',
    },
    labelClient: {
      'en-GB': 'Contact your Client',
      'it-IT': 'Contatta il tuo Client',
    },
    titleFa: {
      'en-GB': 'Do you have any question?<br/>Call {0}.',
      'it-IT': 'Qualcosa non ti è chiaro?<br/>Contatta {0}.',
    },
    descriptionFa: {
      'en-GB':
        "Clear all your doubts and explore the possibilities of your financial profile. Don't hesitate, Qadra is at your disposal.",
      'it-IT':
        'Chiarisci ogni dubbio ed esplora le possibilità del tuo profilo finanziario. Non esitare, Qadra è a tua disposizione.',
    },
    titleClient: {
      'en-GB': 'Do you need more info?<br/>Call your client.',
      'it-IT': 'Ti servono più informazioni?<br/>Contatta il tuo cliente.',
    },
    descriptionClient: {
      'en-GB': 'Get in touch with {0} to clarify some points or update him on your progress.',
      'it-IT':
        'Mettiti in contatto con {0} per chiarire alcuni punti o aggiornarlo sui tuoi avanzamenti.',
    },
  },
  scenarios: {
    label: {
      'en-GB': 'Scenarios',
      'it-IT': 'Scenari',
    },
    equityDrawdown2018: {
      label: {
        'en-GB': 'December 2018 drawdown',
        'it-IT': 'Drawdown dicembre 2018',
      },
      description: {
        'en-GB':
          'In December 2018, global equity markets suffered a drop of over 10% in a few days, following fears of an imminent US recession.',
        'it-IT':
          "Nel dicembre 2018 i mercati azionari globali hanno subito un calo di oltre il 10% in pochi giorni, a seguito dei timori di un'imminente recessione statunitense.",
      },
    },
    chineseBubble: {
      label: {
        'en-GB': 'Chinese stock market turbulence',
        'it-IT': 'Turbolenza mercato azionario Cinese',
      },
      description: {
        'en-GB':
          'Turbulence in Chinese bond markets, after registering an impressive buy run from savers, slightly encouraged by media and brokers.',
        'it-IT':
          "La turbolenza dei mercati obbligazionari cinesi, dopo aver registrato un'impressionante corsa agli acquisti da parte dei risparmiatori, leggermente incoraggiata dai media e dai broker.",
      },
    },
  },
  onboarding: {
    profiling: {
      welcome: {
        subTitle: {
          'en-GB': 'Welcome to Qadra.',
          'it-IT': 'Ti diamo il benvenuto.',
        },
        message: {
          'en-GB':
            'Below are the key steps to building your financial wellbeing.<br/> Are you ready to begin?',
          'it-IT':
            'Questi sono gli step della nostra profilazione.<br />Sei pronto per cominciare a pianificare?',
        },
      },
      accountType: {
        title: {
          'en-GB': 'Choose your profiling',
          'it-IT': 'Seleziona il tipo di profilazione',
        },
        header: {
          'en-GB': "Let's get started.",
          'it-IT': 'Cominciamo.',
        },
        message: {
          'en-GB': 'Choose how to fill your investor profile:',
          'it-IT': 'Seleziona con quale tipologia di profilazione desideri procedere:',
        },
        delegatedProfilingTitle: {
          'en-GB': 'Delegated Profiling',
          'it-IT': 'Profilazione Delegata',
        },
        delegatedProfilingDescription: {
          'en-GB':
            'My Wealth Manager will complete my profile, and I will review it and approve it once ready.',
          'it-IT':
            'Scegliendo questa opzione, verrai notificato quando il tuo Wealth Manager avrà compilato il tuo profilo MiFID, che potrai quindi rivedere e, se corretto, accettare.',
        },
        interactiveProfilingTitle: {
          'en-GB': 'Self Profiling',
          'it-IT': 'Profilazione Interattiva',
        },
        interactiveProfilingDescription: {
          'en-GB':
            'I will complete my profile autonomously. A Wealth Manager can help with anything unclear and advise on the results.',
          'it-IT':
            "Una volta completata la mia profilazione, il mio Wealth Manager potrà rivederla con me e potremo pianificare il piano d'investimento.",
        },
      },
      account: {
        step: {
          'en-GB': 'Create an account',
          'it-IT': 'Crea un account',
        },
        title: {
          'en-GB': 'Which type of account would you like to open?',
          'it-IT': 'Quale tipologia di account vorresti aprire?',
        },
        message: {
          'en-GB': "Choose your account type and the owner's name",
          'it-IT': 'Seleziona il tipo di account che vorresti aprire e il nome degli intestatari.',
        },
        type: {
          'en-GB': 'Account type',
          'it-IT': 'Tipologia di account',
        },
      },
      netWorth: {
        step: {
          'en-GB': 'Current wealth',
          'it-IT': 'Stato patrimoniale',
        },
        title: {
          'en-GB': 'Map your current wealth',
          'it-IT': 'Parlaci del tuo stato patrimoniale',
        },
        assets: {
          header: {
            'en-GB':
              "Let's understand your income and assets to evaluate the right strategy for you.",
            'it-IT': "Inquadra il tuo reddito per valutare il tuo orizzonte d'investimento.",
          },
          alertBoxHeader: {
            'en-GB': 'Why these questions?',
            'it-IT': 'Perchè ti poniamo queste domande?',
          },
          alertBoxSubtitle: {
            'en-GB': 'Invest according to MiFID parameters',
            'it-IT': 'Investire secondo i parametri MiFID',
          },
          alertBoxMessage: {
            'en-GB':
              'According to the MiFID directive, operators such as Qadra are required to have a complete financial picture of their clients to able to offer the right products.',
            'it-IT':
              'Secondo la direttiva MiFID, gli operatori come Qadra sono tenuti ad avere un quadro corretto della condizione economica dei propri clienti, così da poter proporre i prodotti giusti.',
          },
          income: {
            'en-GB': 'Entity of your primary income source',
            'it-IT': 'A quanto ammonta la tua fonte principale di reddito?',
          },
          incomeTooltip: {
            'en-GB': 'Salary, pension, other.',
            'it-IT': 'Stipendio, pensione, altro.',
          },
          otherIncome: {
            'en-GB': 'Entity of your additional income sources (if any)',
            'it-IT': 'A quanto ammontano le altre tue fonti di reddito (se presenti)',
          },
          otherIncomeTooltip: {
            'en-GB': 'Extra earnings (dividends, passive income, etc.)',
            'it-IT': 'Altri redditi (rendite finanziarie, rendite immobiliari, etc.)',
          },
          realEstate: {
            'en-GB': 'Estimated value of your Real Estate',
            'it-IT': 'Beni immobili (valore attuale o di costo)',
          },
          otherInvestments: {
            'en-GB': 'Estimated value of your other investments',
            'it-IT': 'Altri investimenti finanziari (oltre a Qadra)',
          },
          yearlyInvestedAmountTooHighAlert: {
            'en-GB': 'Your annual top up is higher than your annual income.',
            'it-IT': 'Il tuo investmento annuale è più alto del tuo reddito annuale.',
          },
        },
        liabilities: {
          header: {
            'en-GB':
              'Give us an idea of your liabilities to identify the right investment strategy.',
            'it-IT':
              'Adesso definiamo insieme le tue uscite per completare il tuo quadro finanziario.',
          },
          alertBoxHeader: {
            'en-GB': 'How do you define your current wealth?',
            'it-IT': 'Come si definisce lo stato patrimoniale?',
          },
          alertBoxSubtitle: {
            'en-GB': 'A global view on your current wealth',
            'it-IT': 'Una visione patrimoniale omnicomprensiva',
          },
          alertBoxMessage: {
            'en-GB':
              'Enter an estimate of your expenditures (fixed and variable expenditures) and your liabilities (mortgages and other financing).',
            'it-IT':
              'Inserisci una stima delle tue uscite (uscite fissi e variabili) e delle tue passività (mutui e altri finanziamenti)',
          },
          fixedExpenses: {
            'en-GB': 'Your base expenditures',
            'it-IT': 'Quali sono in tuoi costi fissi?',
          },
          fixedExpensesTooltip: {
            'en-GB': 'Housing, bills and other fixed expenses.',
            'it-IT': 'Affitto, utenze mensili, spese studi dei figli.',
          },
          variableExpenses: {
            'en-GB': 'Other variable expenses',
            'it-IT': 'Quali sono le tue uscite variabili?',
          },
          variableExpensesTooltip: {
            'en-GB': 'Other non-recurring or variable expenses.',
            'it-IT': 'Altre uscite non ricorrenti o variabili. ',
          },
          mortgage: {
            'en-GB': 'Outstanding mortgages',
            'it-IT': 'Mutuo (valore attuale)',
          },
          otherLiabilities: {
            'en-GB': 'Other outstanding loans',
            'it-IT': 'Altri finanziamenti (valore attuale)',
          },
          otherLiabilitiesTooltip: {
            'en-GB': 'Other liabilities such as loans.',
            'it-IT': 'Altri finanziamenti, prestiti.',
          },
          liabilitiesHigherThanAssetsAlert: {
            'en-GB':
              'Your annual expenses (including the annual top up) are higher than your annual income.',
            'it-IT':
              "Le tue spese annuali (includendo l'investimento annuale) sono più alte del tuo reddito annuale.",
          },
        },
      },
      objectivesPrologue: {
        header: {
          'en-GB': "Good, let's start from what really matters to you.",
          'it-IT': 'Bene, cominciamo da cosa è più importante per te.',
        },
        subtitle: {
          'en-GB': 'What is Goal-based Investing?',
          'it-IT': "Cos'è il Goal-based Investing?",
        },
        message: {
          'en-GB':
            "Investing by objectives is a process designed to help investors achieve concrete goals by dividing their portfolios according to different objectives.<br/><br/>Have you ever considered a piggy bank for emergencies? Or to finance your children's studies? <br/><br/>Let's think together.",
          'it-IT':
            "Investire per obiettivi è un processo pensato per aiutare l'investitore a raggiungere delle mete concrete, suddividendo il proprio portafoglio in base ai diversi obiettivi.<br/><br/>Hai mai considerato un salvadanaio per le emergenze? O a finanziare gli studi dei tuoi figli?<br/><br/>Ragioniamoci insieme.",
        },
        disclaimer: {
          'en-GB':
            'We identify one goal at a time, starting with your primary goal, leaving you the possibility to add more after the first portfolio is built.',
          'it-IT':
            'Individuiamo un traguardo alla volta, cominciando dal tuo obiettivo primario, lasciandoti la possibilità di aggiungerne altri dopo la costruzione del primo portafoglio.',
        },
        nextButton: {
          'en-GB': 'Find your goals',
          'it-IT': 'Individua i tuoi obiettivi',
        },
      },
      investmentPrologue: {
        header: {
          'en-GB': 'Why investing your capital in Qadra is different.',
          'it-IT': 'Perchè investire il tuo capitale in Qadra è differente.',
        },
        conflictOfInterestTitle: {
          'en-GB': 'No conflict of interest',
          'it-IT': 'Assenza di conflitto di interessi',
        },
        conflictOfInterestDescription: {
          'en-GB':
            'We build your portfolio according to strict scientific processes, selecting funds based on their track record and cost efficiency. We receive no sales commissions of any kind.',
          'it-IT':
            "Costruiamo il tuo portafoglio in base a rigidi processi scientifici, selezionando i fondi in base al loro track record e all'efficienza dei costi. Non percepiamo commissioni di vendita di nessun genere.",
        },
        controlTitle: {
          'en-GB': 'Total transparency',
          'it-IT': 'Un servizio trasparente',
        },
        controlDescription: {
          'en-GB':
            'With Qadra you always have access to your investments and can monitor, in real time, where your money is invested, how much it is making and what costs you are incurring.',
          'it-IT':
            'Con Qadra hai sempre accesso ai tuoi investimenti e puoi monitorare, in tempo reale, dove sono investiti i tuoi soldi, quanto stanno rendendo e quali costi stai sostenendo.',
        },
        strategyTitle: {
          'en-GB': 'Top Level Strategy',
          'it-IT': 'Top Level Strategy',
        },
        strategyDescription: {
          'en-GB':
            'We give you access to the best investment products available on the market, put together for you by Qadra with our strategies to support your goals.',
          'it-IT':
            "Ti diamo accesso ai migliori prodotti d'investimento disponibili sul mercato, messi insieme per te da Qadra con le nostre strategie a supporto dei tuoi obiettivi.",
        },
      },
      objectives: {
        step: {
          'en-GB': 'How to invest',
          'it-IT': 'Come investire',
        },
        title: {
          'en-GB': 'Set your goals',
          'it-IT': 'Parlaci dei tuoi obiettivi',
        },
        header: {
          'en-GB': 'How do you want to build your investment?',
          'it-IT': 'Come vuoi costruire il tuo investimento?',
        },
        message: {
          'en-GB':
            'It is important to understand how you want to manage your capital, whether to plan an investment or to assess your financial situation in global terms.',
          'it-IT':
            'È importante capire come desideri gestire il tuo capitale, se pianificare un investimento o se valutare in termini globali la tua situazione finanziaria.',
        },
        financialPlanTitle: {
          'en-GB': 'Goal-based investing',
          'it-IT': 'Investire per obiettivi',
        },
        financialPlanDescription: {
          'en-GB': 'My primary goal is to build a financial plan for my future ',
          'it-IT': 'Il mio obiettivo primario è costruire un piano finanziario per il mio futuro',
        },
        genericInvestmentTitle: {
          'en-GB': 'Investing capital',
          'it-IT': 'Investire capitale',
        },
        genericInvestmentDescription: {
          'en-GB':
            'My primary objective is to invest capital in order to generate a constant return',
          'it-IT':
            'Il mio obiettivo primario è investire del capitale per generare un rendimento costante',
        },
        selectObjectiveHeader: {
          'en-GB': 'Select your main objective',
          'it-IT': 'Individua il tuo obiettivo primario',
        },
        selectObjectivesMessage: {
          'en-GB':
            'Select your primary goal from those here below, you will always be able to change it or modify it.',
          'it-IT':
            'Seleziona un obiettivo primario, in seguito potrai sempre modificarlo o aggiungerne altri al tuo piano finanziario.',
        },
        investmentDuration: {
          'en-GB': 'Investment horizon',
          'it-IT': "Orizzonte d'investimento",
        },
        riskStrategy: {
          'en-GB': 'Risk level',
          'it-IT': 'Strategia di rischio',
        },
        targetAmount: {
          'en-GB': 'Target amount',
          'it-IT': 'Importo obiettivo',
        },
        genericInvestment: {
          title: {
            'en-GB': 'Investing capital',
            'it-IT': 'Investire capitale',
          },
          header: {
            'en-GB': 'Generate performance and protect your capital.',
            'it-IT': 'Genera performance e proteggi il tuo capitale.',
          },
          shortDescription: {
            'en-GB': 'I want to build a portfolio that can grow over time',
            'it-IT': 'Voglio semplicemente far fruttare il mio capitale',
          },
          description: {
            'en-GB':
              'Put your savings at work. Set your investment parameters, we will take care of finding the right portfolio mix. Your capital will be always available for you, at any time.',
            'it-IT':
              "Metti al lavoro i tuoi risparmi. Stabilisci i tuoi parametri d'investimento, noi ci occuperemo di trovare il mix di portafoglio corretto per te. Inoltre, il tuo capitale non è vincolato ed è sempre a tua disposizione.",
          },
          initialInvestment: {
            'en-GB': 'Initial investment',
            'it-IT': 'Investimento iniziale',
          },
          annualInvestment: {
            'en-GB': 'Annual top up',
            'it-IT': 'Investimento annuale',
          },
          investmentDuration: {
            'en-GB': 'Investment horizon',
            'it-IT': "Orizzonte d'investimento",
          },
        },
        retirement: {
          title: {
            'en-GB': 'Retirement plan',
            'it-IT': 'Rendita vitalizia',
          },
          header: {
            'en-GB': 'The additional pension fund you may need for a bright future.',
            'it-IT': 'Un complemento alla tua pensione,<br/>per un futuro sereno.',
          },
          shortDescription: {
            'en-GB': 'I wish to integrate my pension scheme',
            'it-IT': 'Voglio integrare la mia pensione',
          },
          description: {
            'en-GB':
              'By saving an extra amount each month, you can build a sound financial position to sustain your current lifestyle after your retirement.',
            'it-IT':
              'Inizia da subito ad investire per il tuo periodo di meritato riposo. Un corretto piano di risparmio a lungo termine ti può permettere uno stile di vita senza rinunce.',
          },
          retirementStartAge: {
            'en-GB': 'Retirement age (in years)',
            'it-IT': 'Età inizio pensione (in anni)',
          },
          monthlyIncome: {
            'en-GB': 'Your desired monthly income',
            'it-IT': 'Quale rendita mensile vorresti avere?',
          },
          disclaimerTitle: {
            'en-GB': 'How do we elaborate this plan?',
            'it-IT': 'Come calcoliamo questo piano di risparmio?',
          },
          disclaimerText: {
            'en-GB':
              'We build your retirement plan based on the number of years separating you from your retirement goal. We then calculate the number of retirement years based on life expectancy.',
            'it-IT':
              "Costruiamo il tuo piano di pensionamento in base al numero di anni che ti separano dal tuo obiettivo di pensionamento. Calcoliamo poi il numero di anni di pensionamento in base all'aspettativa di vita.",
          },
        },
        safetyNet: {
          title: {
            'en-GB': 'Financial parachute',
            'it-IT': 'Paracadute',
          },
          header: {
            'en-GB': 'Your financial parachute',
            'it-IT': 'Un paracadute per affrontare sereni il futuro',
          },
          shortDescription: {
            'en-GB': 'I want an emergency fund for rainy days',
            'it-IT': 'Voglio creare un fondo per affrontare imprevisti',
          },
          description: {
            'en-GB':
              'Set up an emergency portfolio for the rainy days.<br/>Put your savings apart in a low-risk investment plan with no holding limitations, so that you can always count on it.',
            'it-IT':
              "Dotati di un paracadute finanziario per affrontare gli imprevisti.<br />Metti da parte i tuo risparmi con un programma d'investimento a basso rischio e senza alcun vincolo, sul quale poter fare affidamento in qualsiasi momento.",
          },
          targetAmount: {
            'en-GB': "What's the desired fund size?",
            'it-IT': 'Quale somma vuoi tenere a tua disposizione?',
          },
          investmentDuration: {
            'en-GB': 'How quickly do you wish to build up your emergency fund?',
            'it-IT': 'In quanto tempo vuoi raggiungere questa somma?',
          },
        },
        expense: {
          title: {
            'en-GB': 'Important purchase',
            'it-IT': 'Spesa',
          },
          header: {
            'en-GB': 'Realise your dreams.',
            'it-IT': 'Realizza i tuoi sogni.',
          },
          shortDescription: {
            'en-GB': 'I want to save for a future purchase',
            'it-IT': 'Voglio risparmiare per un acquisto importante',
          },
          description: {
            'en-GB':
              "Start investing now to get the cash you need for your dream purchase. Be it your new home, or your kids' college.",
            'it-IT':
              'Costruisci un piano di risparmio che ti aiuti a raggiungere i tuoi obiettivi di acquisto. Che si tratti della tua nuova casa o degli studi dei tuoi figli, con pochi semplici input possiamo elaborare un piano adeguato.',
          },
          type: {
            'en-GB': 'Which purchase are you planning?',
            'it-IT': 'Quale tipologia di spesa stai pianificando?',
          },
          typeExample: {
            'en-GB': 'Ex. Buy a house',
            'it-IT': 'Es. Acquisto casa',
          },
          targetAmount: {
            'en-GB': 'How much money will you need?',
            'it-IT': 'Quanto denaro ti occorre?',
          },
          investmentDuration: {
            'en-GB': 'In how long time?',
            'it-IT': 'Tra quanto tempo?',
          },
        },
      },
      experience: {
        step: {
          'en-GB': 'Expertise',
          'it-IT': 'Esperienza',
        },
        title: {
          'en-GB': 'Share your experience',
          'it-IT': 'Valutiamo la tua esperienza',
        },
        header: {
          'en-GB': 'Your financial expertise.',
          'it-IT': 'La tua esperienza finanziaria ad oggi.',
        },
        alertBoxTitle: {
          'en-GB': 'What does it mean to have a "financial culture"?',
          'it-IT': 'Cosa significa avere una "cultura finanziaria"?',
        },
        alertBoxSubtitle: {
          'en-GB': 'Why these questions?',
          'it-IT': 'Perchè è importante?',
        },
        alertBoxMessage: {
          'en-GB':
            'Evaluating your financial expertise is fundamental in order to understand the complexity of your portfolio and the associated risk level.',
          'it-IT':
            'Valutare la tua esperienza di investitore è fondamentale per scegliere strumenti finanziari allineati con il tuo grado di conoscenza.',
        },
        tradedInstrumentsLabel: {
          'en-GB':
            'Pick any financial products you have invested in or you are currently investing in',
          'it-IT':
            'Seleziona i prodotti finanziari in cui stai attualmente investendo o hai investito in passato',
        },
        tradedInstruments: {
          'en-GB': ['Stocks', 'Corporate Bonds', 'Government Bonds', 'Mutual Funds & ETFs', 'None'],
          'it-IT': [
            'Azioni',
            'Obbligazioni',
            'Titoli di Stato',
            "Fondi comuni d'investimento",
            'Nessuna esperienza finanziaria',
          ],
        },
        investedAmountLabel: {
          'en-GB': 'How much have you invested so far?',
          'it-IT': 'A quanto ammontano i tuoi investimenti in strumenti finanziari?',
        },
        investmentAmount: {
          'en-GB': [
            '0€ to 50.000€',
            '50.000€ to 100.000€',
            '100.000€ to 500.000€',
            'More than 500.000 €',
          ],
          'it-IT': ['0€ a 50.000€', '50.000€ a 100.000€', '100.000€ a 500.000€', 'Più di 500.000€'],
        },
        investmentDurationLabel: {
          'en-GB': 'For how long have you been investing so far?',
          'it-IT': 'Da quanto tempo fai investimenti finanziari?',
        },
        investmentDuration: {
          'en-GB': ['Less than an year', '1 to 2 years', '2 to 5 years', 'More than 5 years'],
          'it-IT': ['Da 0 a 1 anno', 'Da 1 a 2 anni', 'Da 2 a 5 anni', 'Più di 5 anni'],
        },
      },
      strategy: {
        step: {
          'en-GB': 'Strategy',
          'it-IT': 'Strategia',
        },
        return: {
          title: {
            'en-GB': 'Attitude to risk',
            'it-IT': 'Propensione al rischio',
          },
          subtitle: {
            'en-GB':
              "At current interest rates, an Italian government bond (e.g. BOT, CCT) yields, on average, 0.7% per year. If you invest 10,000 Euro, after one year you would have a gross gain of 70 Euro.<br/>The investment portfolios are designed to give a higher return, balancing and diversifying the risk according to the client's preferences.",
            'it-IT':
              'Ai tassi d’interesse attuali, un Titolo di Stato italiano (es. BOT, CCT) rende, in media, lo 0,7% annuo. Investendo così 10.000 Euro, dopo un anno avresti un guadagno lordo di 70 Euro.<br/>I portafogli di investimento sono studiati per dare un rendimento maggiore, bilanciando e diversificando il rischio in base alle preferenze del cliente. ',
          },
          descriptionTitle: {
            'en-GB': 'What is return?',
            'it-IT': "Cos'è il rendimento?",
          },
          description: {
            'en-GB':
              'Return is an important element of your investment strategy, as it helps determine the level of risk you need to maintain in order to achieve your objectives.',
            'it-IT':
              'Il rendimento è un elemento importante della tua strategia d’investimento, in quanto concorre a determinare il livello di rischio da mantenere per raggiungere i propri obiettivi.',
          },
          question: {
            'en-GB': 'That being said, how would you behave:',
            'it-IT': 'Detto ciò, in che modo ti comporteresti:',
          },
          answers: {
            1: {
              'en-GB': "I don't know",
              'it-IT': 'Non saprei',
            },
            2: {
              'en-GB':
                'I would feel comfortable with a diversified portfolio while maintaining a return and risk profile similar to government bonds.',
              'it-IT':
                'Mi sentirei a mio agio con un portafoglio diversificato, mantenendo però un rendimento e un profilo di rischio analogo ai Titoli di Stato.',
            },
            3: {
              'en-GB':
                'I would like a slightly higher return, while maintaining a low risk profile and still preferring bonds with a high credit rating.',
              'it-IT':
                'Vorrei un rendimento leggermente superiore, mantenendo però un profilo di rischio basso e privilegiando comunque titoli obbligazionari ad alto merito creditizio.',
            },
            4: {
              'en-GB':
                'I would like a decidedly higher return as I have financial objectives to achieve for which I need to make a return on my capital.',
              'it-IT':
                'Vorrei un rendimento decisamente maggiore, in quanto ho degli obiettivi finanziari da raggiungere per cui ho bisogno di far fruttare il mio capitale.',
            },
            5: {
              'en-GB':
                'I would like to invest in instruments with strong growth potential (e.g. equities), taking high risks if necessary.',
              'it-IT':
                'Vorrei investire in strumenti che abbiano un forte potenziale di crescita (es. azioni), correndo dei rischi elevati se necessario.',
            },
          },
        },
        maxDrawdown: {
          title: {
            'en-GB': 'Sensitivity to market drops',
            'it-IT': 'Sensibilità ai ribassi di mercato',
          },
          subtitle: {
            'en-GB':
              'The outbreak of the crisis at COVID-19 represented one of the most sudden and drastic losses in value for the financial markets ever. Between February and March 2020, the markets lost about 25% of their pre-crisis values.',
            'it-IT':
              'L’esplosione della crisi da COVID-19 ha rappresentato, per i mercati finanziari, una delle perdite di valore più repentine e drastiche di sempre. Tra febbraio e marzo 2020, i mercati sono arrivati a perdere circa il 25% dai valori pre-crisi.            ',
          },
          descriptionTitle: {
            'en-GB': 'What is drawdown?',
            'it-IT': "Cos'è il drawdown?",
          },
          description: {
            'en-GB':
              'All markets are experiencing moments of decline due to the most diverse factors. In jargon these moments are called "Maximum Drawdown" and are followed by a recovery phase, more or less fast ("Time to Recovery").',
            'it-IT':
              'Tutti i mercati conoscono dei momenti di ribasso dovuti ai fattori più diversi. In gergo questi momenti sono detti di “Massimo Drawdown” e sono seguiti da una fase di recupero, più o meno veloce (“Time to Recovery”).',
          },
          question: {
            'en-GB': 'In such a scenario, how would you have behaved?',
            'it-IT': 'In uno scenario del genere, come ti saresti comportato?',
          },
          answers: {
            1: {
              'en-GB': "I don't know",
              'it-IT': 'Non saprei',
            },
            2: {
              'en-GB':
                'I would have liquidated all my investments, even at the cost of crystallizing major losses.',
              'it-IT':
                'Avrei liquidato tutti i miei investimenti, anche a costo di cristallizzare delle perdite importanti.',
            },
            3: {
              'en-GB':
                'I would have kept my investments, waiting and trying to reduce my exposure without making further investments.',
              'it-IT':
                'Avrei mantenuto i miei investimenti, aspettando e cercando tuttalpiù di ridurre la mia esposizione, senza effettuare ulteriori investimenti.',
            },
            4: {
              'en-GB':
                'I would have kept the situation under control continuously, trying to identify any opportunities for new investments.',
              'it-IT':
                'Avrei tenuto sotto controllo la situazione in modo continuo, cercando di individuare eventuali opportunità per nuovi investimenti.',
            },
            5: {
              'en-GB':
                'I would have taken advantage of the sharp drop in financial security prices to make new investments.',
              'it-IT':
                'Avrei approfittato del forte calo dei prezzi dei titoli finanziari per effettuare nuovi investimenti.',
            },
          },
        },
        volatility: {
          title: {
            'en-GB': 'Approach to market swings',
            'it-IT': 'Percezione della volatilità',
          },
          subtitle: {
            'en-GB':
              'You invested in a portfolio of securities that was 5% positive after six months. However, after 12 months the portfolio performed negatively, showing a net loss of 2% for your invested capital.',
            'it-IT':
              'Hai investito in un portafoglio di titoli che dopo sei mesi era in positivo per il 5%. Tuttavia, dopo 12 mesi il portafoglio ha registrato una performance negativa, presentando una perdita netta del 2% per il tuo capitale investito.',
          },
          descriptionTitle: {
            'en-GB': 'What is volatility?',
            'it-IT': "Che cos'è la volatilità?",
          },
          description: {
            'en-GB':
              'The alternation of moments of growth and degrowth is what in technical terms is called "Volatility". Normally, the more ambitious a portfolio is, the more it leads to volatility. This is a key factor to consider when investing and is one of the reference points in determining the composition of a portfolio.',
            'it-IT':
              'L’alternarsi di momenti di crescita e decrescita è ciò che in termini tecnici si chiama “Volatilità”. Normalmente, più un portafoglio è ambizioso più comporta una certa volatilità. Questo è un fattore chiave da considerare quando si investe ed è uno dei punti di riferimento nel determinare la composizione di un portafoglio.',
          },
          question: {
            'en-GB': 'In such a situation:',
            'it-IT': 'In una situazione di questo tipo:',
          },
          answers: {
            1: {
              'en-GB': "I don't know",
              'it-IT': 'Non saprei',
            },
            2: {
              'en-GB':
                'I would consult with an experienced person to better understand how to behave.',
              'it-IT':
                'Mi consulterei con una persona esperta, in modo da capire meglio come comportarmi.',
            },
            3: {
              'en-GB':
                'I would liquidate the portfolio, even at the cost of crystallizing a loss of 2%.',
              'it-IT':
                'Liquiderei il portafoglio, anche a costo di cristallizzare una perdita del 2%.',
            },
            4: {
              'en-GB': 'I would keep my portfolio unchanged, waiting to recover the losses.',
              'it-IT':
                'Manterrei invariato il mio portafoglio, in attesa di recuperare le perdite.',
            },
            5: {
              'en-GB':
                'I would take advantage of this to add an additional amount, taking advantage of the moment of decline.',
              'it-IT':
                'Ne approfitterei per aggiungere una somma aggiuntiva, approfittando del momento di ribasso.',
            },
          },
        },
      },
      profile: {
        step: {
          'en-GB': 'Risk profile',
          'it-IT': 'Profilo di rischio',
        },
        title: {
          'en-GB': 'Get your investor profile',
          'it-IT': 'Il tuo profilo di rischio',
        },
        header: {
          'en-GB': 'Your risk profile is: ',
          'it-IT': 'Il tuo profilo di rischio è: ',
        },
        alertBoxTitle: {
          'en-GB': 'Why this risk profile?',
          'it-IT': 'Perchè questo profilo di rischio?',
        },
        alertBoxMessage: {
          'en-GB':
            'Your MiFID risk profile is the result of the answers you provided so far. It is the result of the need to balance your expertise level with your financial soundness, your goals and your risk appetite.',
          'it-IT':
            'Il tuo profilo MiFID è il risultato dei diversi aspetti del tuo profilo di investitore. Si tratta di un bilanciamento tra la tua esperienza, la tua capacità di assorbire perdite, i tuoi obiettivi e la tua propensione al rischio.',
        },
        yourProfile: {
          'en-GB': 'Your profile',
          'it-IT': 'Il tuo profilo',
        },
        profileDescriptionLabel: {
          'en-GB': 'Description portfolio-type profile:',
          'it-IT': 'Descrizione portfolio-tipo del profilo:',
        },
        profileDescription: {
          1: {
            'en-GB':
              'My risk profile involves a maximum allocation of 10% of my portfolio value in high risk asset classes (equities, commodities, and derivatives) and up to 90% in low risk asset classes (bonds, money market, liquidity).',
            'it-IT':
              'Il mio profilo prevede un investimento massimo del 10% del mio portafoglio sulle asset class più rischiose (azionario, commodities e altri prodotti derivati) e fino al 90% sulle asset class meno rischiose (obbligazionario, mercato monetario, liquidità).',
          },
          2: {
            'en-GB':
              'My risk profile involves a maximum allocation of 25% of my portfolio value in high risk asset classes (equities, commodities, and derivatives) and up to 75% in low risk asset classes (bonds, money market, liquidity).',
            'it-IT':
              'Il mio profilo prevede un investimento massimo del 25% del mio portafoglio sulle asset class più rischiose (azionario, commodities e altri prodotti derivati) e fino al 75% sulle asset class meno rischiose (obbligazionario, mercato monetario, liquidità).',
          },
          3: {
            'en-GB':
              'My risk profile involves a maximum allocation of 45% of my portfolio value in high risk asset classes (equities, commodities, and derivatives) and up to 55% in low risk asset classes (bonds, money market, liquidity).',
            'it-IT':
              'Il mio profilo prevede un investimento massimo del 45% del mio portafoglio sulle asset class più rischiose (azionario, commodities e altri prodotti derivati) e fino al 55% sulle asset class meno rischiose (obbligazionario, mercato monetario, liquidità).',
          },
          4: {
            'en-GB':
              'My risk profile involves a maximum allocation of 75% of my portfolio value in high risk asset classes (equities, commodities, and derivatives) and up to 25% in low risk asset classes (bonds, money market, liquidity).',
            'it-IT':
              'Il mio profilo prevede un investimento massimo del 75% del mio portafoglio sulle asset class più rischiose (azionario, commodities e altri prodotti derivati) e fino al 25% sulle asset class meno rischiose (obbligazionario, mercato monetario, liquidità).',
          },
          5: {
            'en-GB':
              'My risk profile involves a maximum allocation of 10% of my portfolio value in high risk asset classes (equities, commodities, and derivatives).',
            'it-IT':
              'Il mio profilo prevede un investimento massimo del 100% del mio portafoglio sulle asset class più rischiose (azionario, commodities e altri prodotti derivati).',
          },
        },
        acceptProfileButton: {
          'en-GB': 'Accept and go to investment proposals',
          'it-IT': 'Accetta profilo e vai alle proposte',
        },
        redoProfilingButton: {
          'en-GB': 'Do you want to recalculate you profile? Click here',
          'it-IT': 'Vuoi ricalcolare il tuo profilo? Clicca qui',
        },
      },
    },
  },
  portfolioSection: {
    portfolioValue: {
      'en-GB': 'Portfolio value',
      'it-IT': 'Valore portafoglio',
    },
    overviewFromCreationDate: {
      'en-GB': 'Overview portfolio from creation date',
      'it-IT': 'Overview portafoglio dalla data di creazione',
    },
    totalInvestedAmount: {
      'en-GB': 'Your investment',
      'it-IT': 'Quanto hai investito',
    },
    totalReturn: {
      'en-GB': 'Gross return',
      'it-IT': 'Quanto hai guadagnato',
    },
    totalFees: {
      'en-GB': 'Qadra fees',
      'it-IT': 'Commissioni Qadra',
    },
    totalNetReturn: {
      'en-GB': 'Net return',
      'it-IT': 'Guadagno netto',
    },
  },
  walletSection: {
    yourQadraPortfolio: {
      'en-GB': 'Your Qadra portfolios',
      'it-IT': 'I tuoi portafogli in Qadra',
    },
  },
  timeHorizon: {
    short: {
      name: {
        'en-GB': 'Short term',
        'it-IT': 'Breve termine',
      },
      description: {
        'en-GB': 'I have a short term investment horizon, taking a slightly lower risk.',
        'it-IT':
          "Ho un orizzonte d'investimento a breve termine, assumendo un rischio leggermente minore.",
      },
    },
    mid: {
      name: {
        'en-GB': 'Mid term',
        'it-IT': 'Medio termine',
      },
      description: {
        'en-GB':
          'I have an investment horizon between 2 and 5 years, I can start to verify performance after the first 12 months.',
        'it-IT':
          "Ho un orizzonte d'investimento tra i 2 ed i 5 anni, posso iniziare a verificare le performance dopo i primi 12 mesi.",
      },
    },
    long: {
      name: {
        'en-GB': 'Long term',
        'it-IT': 'Lungo termine',
      },
      description: {
        'en-GB':
          'I have an investment horizon of 6 years or more and I do not think I need this capital in the short to medium term. I can aim for long-term results.',
        'it-IT':
          "Ho un orizzonte d'investimento di 6 anni o più e non credo di aver bisogno di questo capitale nel breve-medio termine. Posso puntare a ottenere dei risultati nel lungo termine.",
      },
    },
  },
  investmentsSection: {
    title: {
      'en-GB': 'Investments',
      'it-IT': 'Investimenti',
    },
  },
  objectivesName: {
    SafetyNet: {
      'en-GB': 'Financial parachute',
      'it-IT': 'Paracadute',
    },
    GenericInvestment: {
      'en-GB': 'Investment',
      'it-IT': 'Investmento',
    },
    Expense: {
      'en-GB': 'Important purchase',
      'it-IT': 'Spesa',
    },
    Retirement: {
      'en-GB': 'Retirement plan',
      'it-IT': 'Rendita vitalizia',
    },
  },
};
